/* Prototipo de Departamento */
export interface Departamento {
  nombre: string;
  codigo: string;
  normalizado: string;
}

/* Prototipo de Ciudad */
export interface Ciudad {
  nombre: string;
  codigo: string;
  departamento: string;
  normalizada: string;
}

/* Datos de los departamentos */
export const DATOS_DEPARTAMENTOS: Departamento[] = [
  {
    nombre: 'Amazonas',
    codigo: '91',
    normalizado: 'amazonas',
  },
  {
    nombre: 'Antioquia',
    codigo: '5',
    normalizado: 'antioquia',
  },
  {
    nombre: 'Arauca',
    codigo: '81',
    normalizado: 'arauca',
  },
  {
    nombre: 'Archipiélago de San Andrés, Providencia y Santa Catalina',
    codigo: '88',
    normalizado: 'archipielagodesanandres,providenciaysantacatalina',
  },
  {
    nombre: 'Atlántico',
    codigo: '8',
    normalizado: 'atlantico',
  },
  {
    nombre: 'Bogotá',
    codigo: '11',
    normalizado: 'bogota',
  },
  {
    nombre: 'Bolívar',
    codigo: '13',
    normalizado: 'bolivar',
  },
  {
    nombre: 'Boyacá',
    codigo: '15',
    normalizado: 'boyaca',
  },
  {
    nombre: 'Caldas',
    codigo: '17',
    normalizado: 'caldas',
  },
  {
    nombre: 'Caquetá',
    codigo: '18',
    normalizado: 'caqueta',
  },
  {
    nombre: 'Casanare',
    codigo: '85',
    normalizado: 'casanare',
  },
  {
    nombre: 'Cauca',
    codigo: '19',
    normalizado: 'cauca',
  },
  {
    nombre: 'Cesár',
    codigo: '20',
    normalizado: 'cesar',
  },
  {
    nombre: 'Chocó',
    codigo: '27',
    normalizado: 'choco',
  },
  {
    nombre: 'Córdoba',
    codigo: '23',
    normalizado: 'cordoba',
  },
  {
    nombre: 'Cundinamarca',
    codigo: '25',
    normalizado: 'cundinamarca',
  },
  {
    nombre: 'Guainía',
    codigo: '94',
    normalizado: 'guainia',
  },
  {
    nombre: 'Guaviare',
    codigo: '95',
    normalizado: 'guaviare',
  },
  {
    nombre: 'Huila',
    codigo: '41',
    normalizado: 'huila',
  },
  {
    nombre: 'La Guajira',
    codigo: '44',
    normalizado: 'laguajira',
  },
  {
    nombre: 'Magdalena',
    codigo: '47',
    normalizado: 'magdalena',
  },
  {
    nombre: 'Meta',
    codigo: '50',
    normalizado: 'meta',
  },
  {
    nombre: 'Nariño',
    codigo: '52',
    normalizado: 'narino',
  },
  {
    nombre: 'Norte de Santander',
    codigo: '54',
    normalizado: 'nortedesantander',
  },
  {
    nombre: 'Putumayo',
    codigo: '86',
    normalizado: 'putumayo',
  },
  {
    nombre: 'Quindío',
    codigo: '63',
    normalizado: 'quindio',
  },
  {
    nombre: 'Risaralda',
    codigo: '66',
    normalizado: 'risaralda',
  },
  {
    nombre: 'Santander',
    codigo: '68',
    normalizado: 'santander',
  },
  {
    nombre: 'Sucre',
    codigo: '70',
    normalizado: 'sucre',
  },
  {
    nombre: 'Tolima',
    codigo: '73',
    normalizado: 'tolima',
  },
  {
    nombre: 'Valle del Cauca',
    codigo: '76',
    normalizado: 'valledelcauca',
  },
  {
    nombre: 'Vaupés',
    codigo: '97',
    normalizado: 'vaupes',
  },
  {
    nombre: 'Vichada',
    codigo: '99',
    normalizado: 'vichada',
  },
];

/* Datos de las ciudades */
export const DATOS_CIUDADES: Ciudad[] = [
  {
    nombre: 'Abejorral',
    codigo: '5.002',
    departamento: 'Antioquia',
    normalizada: 'abejorral',
  },
  {
    nombre: 'Ábrego',
    codigo: '54.003',
    departamento: 'Norte de Santander',
    normalizada: 'abrego',
  },
  {
    nombre: 'Abriaquí',
    codigo: '5.004',
    departamento: 'Antioquia',
    normalizada: 'abriaqui',
  },
  {
    nombre: 'Acacías',
    codigo: '50.006',
    departamento: 'Meta',
    normalizada: 'acacias',
  },
  {
    nombre: 'Acandí',
    codigo: '27.006',
    departamento: 'Chocó',
    normalizada: 'acandi',
  },
  {
    nombre: 'Acevedo',
    codigo: '41.006',
    departamento: 'Huila',
    normalizada: 'acevedo',
  },
  {
    nombre: 'Achí',
    codigo: '13.006',
    departamento: 'Bolívar',
    normalizada: 'achi',
  },
  {
    nombre: 'Agrado',
    codigo: '41.013',
    departamento: 'Huila',
    normalizada: 'agrado',
  },
  {
    nombre: 'Agua de Dios',
    codigo: '25.001',
    departamento: 'Cundinamarca',
    normalizada: 'aguadedios',
  },
  {
    nombre: 'Aguachica',
    codigo: '20.011',
    departamento: 'Cesár',
    normalizada: 'aguachica',
  },
  {
    nombre: 'Aguada',
    codigo: '68.013',
    departamento: 'Santander',
    normalizada: 'aguada',
  },
  {
    nombre: 'Aguadas',
    codigo: '17.013',
    departamento: 'Caldas',
    normalizada: 'aguadas',
  },
  {
    nombre: 'Aguazul',
    codigo: '85.01',
    departamento: 'Casanare',
    normalizada: 'aguazul',
  },
  {
    nombre: 'Agustín Codazzi',
    codigo: '20.013',
    departamento: 'Cesár',
    normalizada: 'agustincodazzi',
  },
  {
    nombre: 'Aipe',
    codigo: '41.016',
    departamento: 'Huila',
    normalizada: 'aipe',
  },
  {
    nombre: 'Albán',
    codigo: '52.019',
    departamento: 'Nariño',
    normalizada: 'alban',
  },
  {
    nombre: 'Albán',
    codigo: '25.019',
    departamento: 'Cundinamarca',
    normalizada: 'alban',
  },
  {
    nombre: 'Albania',
    codigo: '18.029',
    departamento: 'Caquetá',
    normalizada: 'albania',
  },
  {
    nombre: 'Albania',
    codigo: '44.035',
    departamento: 'La Guajira',
    normalizada: 'albania',
  },
  {
    nombre: 'Albania',
    codigo: '68.02',
    departamento: 'Santander',
    normalizada: 'albania',
  },
  {
    nombre: 'Alcalá',
    codigo: '76.02',
    departamento: 'Valle del Cauca',
    normalizada: 'alcala',
  },
  {
    nombre: 'Aldana',
    codigo: '52.022',
    departamento: 'Nariño',
    normalizada: 'aldana',
  },
  {
    nombre: 'Alejandría',
    codigo: '5.021',
    departamento: 'Antioquia',
    normalizada: 'alejandria',
  },
  {
    nombre: 'Algarrobo',
    codigo: '47.03',
    departamento: 'Magdalena',
    normalizada: 'algarrobo',
  },
  {
    nombre: 'Algeciras',
    codigo: '41.02',
    departamento: 'Huila',
    normalizada: 'algeciras',
  },
  {
    nombre: 'Almaguer',
    codigo: '19.022',
    departamento: 'Cauca',
    normalizada: 'almaguer',
  },
  {
    nombre: 'Almeida',
    codigo: '15.022',
    departamento: 'Boyacá',
    normalizada: 'almeida',
  },
  {
    nombre: 'Alpujarra',
    codigo: '73.024',
    departamento: 'Tolima',
    normalizada: 'alpujarra',
  },
  {
    nombre: 'Altamira',
    codigo: '41.026',
    departamento: 'Huila',
    normalizada: 'altamira',
  },
  {
    nombre: 'Alto Baudó',
    codigo: '27.025',
    departamento: 'Chocó',
    normalizada: 'altobaudo',
  },
  {
    nombre: 'Altos del Rosario',
    codigo: '13.03',
    departamento: 'Bolívar',
    normalizada: 'altosdelrosario',
  },
  {
    nombre: 'Alvarado',
    codigo: '73.026',
    departamento: 'Tolima',
    normalizada: 'alvarado',
  },
  {
    nombre: 'Amagá',
    codigo: '5.03',
    departamento: 'Antioquia',
    normalizada: 'amaga',
  },
  {
    nombre: 'Amalfi',
    codigo: '5.031',
    departamento: 'Antioquia',
    normalizada: 'amalfi',
  },
  {
    nombre: 'Ambalema',
    codigo: '73.03',
    departamento: 'Tolima',
    normalizada: 'ambalema',
  },
  {
    nombre: 'Anapoima',
    codigo: '25.035',
    departamento: 'Cundinamarca',
    normalizada: 'anapoima',
  },
  {
    nombre: 'Ancuyá',
    codigo: '52.036',
    departamento: 'Nariño',
    normalizada: 'ancuya',
  },
  {
    nombre: 'Andalucía',
    codigo: '76.036',
    departamento: 'Valle del Cauca',
    normalizada: 'andalucia',
  },
  {
    nombre: 'Andes',
    codigo: '5.034',
    departamento: 'Antioquia',
    normalizada: 'andes',
  },
  {
    nombre: 'Angelópolis',
    codigo: '5.036',
    departamento: 'Antioquia',
    normalizada: 'angelopolis',
  },
  {
    nombre: 'Angostura',
    codigo: '5.038',
    departamento: 'Antioquia',
    normalizada: 'angostura',
  },
  {
    nombre: 'Anolaima',
    codigo: '25.04',
    departamento: 'Cundinamarca',
    normalizada: 'anolaima',
  },
  {
    nombre: 'Anorí',
    codigo: '5.04',
    departamento: 'Antioquia',
    normalizada: 'anori',
  },
  {
    nombre: 'Anserma',
    codigo: '17.042',
    departamento: 'Caldas',
    normalizada: 'anserma',
  },
  {
    nombre: 'Ansermanuevo',
    codigo: '76.041',
    departamento: 'Valle del Cauca',
    normalizada: 'ansermanuevo',
  },
  {
    nombre: 'Anzá',
    codigo: '5.044',
    departamento: 'Antioquia',
    normalizada: 'anza',
  },
  {
    nombre: 'Anzoátegui',
    codigo: '73.043',
    departamento: 'Tolima',
    normalizada: 'anzoategui',
  },
  {
    nombre: 'Apartadó',
    codigo: '5.045',
    departamento: 'Antioquia',
    normalizada: 'apartado',
  },
  {
    nombre: 'Apía',
    codigo: '66.045',
    departamento: 'Risaralda',
    normalizada: 'apia',
  },
  {
    nombre: 'Apulo',
    codigo: '25.599',
    departamento: 'Cundinamarca',
    normalizada: 'apulo',
  },
  {
    nombre: 'Aquitania',
    codigo: '15.047',
    departamento: 'Boyacá',
    normalizada: 'aquitania',
  },
  {
    nombre: 'Aracataca',
    codigo: '47.053',
    departamento: 'Magdalena',
    normalizada: 'aracataca',
  },
  {
    nombre: 'Aranzazu',
    codigo: '17.05',
    departamento: 'Caldas',
    normalizada: 'aranzazu',
  },
  {
    nombre: 'Aratoca',
    codigo: '68.051',
    departamento: 'Santander',
    normalizada: 'aratoca',
  },
  {
    nombre: 'Arauca',
    codigo: '81.001',
    departamento: 'Arauca',
    normalizada: 'arauca',
  },
  {
    nombre: 'Arauquita',
    codigo: '81.065',
    departamento: 'Arauca',
    normalizada: 'arauquita',
  },
  {
    nombre: 'Arbeláez',
    codigo: '25.053',
    departamento: 'Cundinamarca',
    normalizada: 'arbelaez',
  },
  {
    nombre: 'Arboleda',
    codigo: '52.051',
    departamento: 'Nariño',
    normalizada: 'arboleda',
  },
  {
    nombre: 'Arboledas',
    codigo: '54.051',
    departamento: 'Norte de Santander',
    normalizada: 'arboledas',
  },
  {
    nombre: 'Arboletes',
    codigo: '5.051',
    departamento: 'Antioquia',
    normalizada: 'arboletes',
  },
  {
    nombre: 'Arcabuco',
    codigo: '15.051',
    departamento: 'Boyacá',
    normalizada: 'arcabuco',
  },
  {
    nombre: 'Arenal',
    codigo: '13.042',
    departamento: 'Bolívar',
    normalizada: 'arenal',
  },
  {
    nombre: 'Argelia',
    codigo: '5.055',
    departamento: 'Antioquia',
    normalizada: 'argelia',
  },
  {
    nombre: 'Argelia',
    codigo: '19.05',
    departamento: 'Cauca',
    normalizada: 'argelia',
  },
  {
    nombre: 'Argelia',
    codigo: '76.054',
    departamento: 'Valle del Cauca',
    normalizada: 'argelia',
  },
  {
    nombre: 'Ariguaní',
    codigo: '47.058',
    departamento: 'Magdalena',
    normalizada: 'ariguani',
  },
  {
    nombre: 'Arjona',
    codigo: '13.052',
    departamento: 'Bolívar',
    normalizada: 'arjona',
  },
  {
    nombre: 'Armenia',
    codigo: '5.059',
    departamento: 'Antioquia',
    normalizada: 'armenia',
  },
  {
    nombre: 'Armenia',
    codigo: '63.001',
    departamento: 'Quindío',
    normalizada: 'armenia',
  },
  {
    nombre: 'Armero',
    codigo: '73.055',
    departamento: 'Tolima',
    normalizada: 'armero',
  },
  {
    nombre: 'Arroyohondo',
    codigo: '13.062',
    departamento: 'Bolívar',
    normalizada: 'arroyohondo',
  },
  {
    nombre: 'Astrea',
    codigo: '20.032',
    departamento: 'Cesár',
    normalizada: 'astrea',
  },
  {
    nombre: 'Ataco',
    codigo: '73.067',
    departamento: 'Tolima',
    normalizada: 'ataco',
  },
  {
    nombre: 'Atrato',
    codigo: '27.05',
    departamento: 'Chocó',
    normalizada: 'atrato',
  },
  {
    nombre: 'Ayapel',
    codigo: '23.068',
    departamento: 'Córdoba',
    normalizada: 'ayapel',
  },
  {
    nombre: 'Bagadó',
    codigo: '27.073',
    departamento: 'Chocó',
    normalizada: 'bagado',
  },
  {
    nombre: 'Bahía Solano',
    codigo: '27.075',
    departamento: 'Chocó',
    normalizada: 'bahiasolano',
  },
  {
    nombre: 'Bajo Baudó',
    codigo: '27.077',
    departamento: 'Chocó',
    normalizada: 'bajobaudo',
  },
  {
    nombre: 'Balboa',
    codigo: '19.075',
    departamento: 'Cauca',
    normalizada: 'balboa',
  },
  {
    nombre: 'Balboa',
    codigo: '66.075',
    departamento: 'Risaralda',
    normalizada: 'balboa',
  },
  {
    nombre: 'Baranoa',
    codigo: '8.078',
    departamento: 'Atlántico',
    normalizada: 'baranoa',
  },
  {
    nombre: 'Baraya',
    codigo: '41.078',
    departamento: 'Huila',
    normalizada: 'baraya',
  },
  {
    nombre: 'Barbacoas',
    codigo: '52.079',
    departamento: 'Nariño',
    normalizada: 'barbacoas',
  },
  {
    nombre: 'Barbosa',
    codigo: '5.079',
    departamento: 'Antioquia',
    normalizada: 'barbosa',
  },
  {
    nombre: 'Barbosa',
    codigo: '68.077',
    departamento: 'Santander',
    normalizada: 'barbosa',
  },
  {
    nombre: 'Barichara',
    codigo: '68.079',
    departamento: 'Santander',
    normalizada: 'barichara',
  },
  {
    nombre: 'Barranca de Upía',
    codigo: '50.11',
    departamento: 'Meta',
    normalizada: 'barrancadeupia',
  },
  {
    nombre: 'Barrancabermeja',
    codigo: '68.081',
    departamento: 'Santander',
    normalizada: 'barrancabermeja',
  },
  {
    nombre: 'Barrancas',
    codigo: '44.078',
    departamento: 'La Guajira',
    normalizada: 'barrancas',
  },
  {
    nombre: 'Barranco de Loba',
    codigo: '13.074',
    departamento: 'Bolívar',
    normalizada: 'barrancodeloba',
  },
  {
    nombre: 'Barranco Minas',
    codigo: '94.343',
    departamento: 'Guainía',
    normalizada: 'barrancominas',
  },
  {
    nombre: 'Barranquilla',
    codigo: '8.001',
    departamento: 'Atlántico',
    normalizada: 'barranquilla',
  },
  {
    nombre: 'Becerril',
    codigo: '20.045',
    departamento: 'Cesár',
    normalizada: 'becerril',
  },
  {
    nombre: 'Belalcázar',
    codigo: '17.088',
    departamento: 'Caldas',
    normalizada: 'belalcazar',
  },
  {
    nombre: 'Belén',
    codigo: '52.083',
    departamento: 'Nariño',
    normalizada: 'belen',
  },
  {
    nombre: 'Belén',
    codigo: '15.087',
    departamento: 'Boyacá',
    normalizada: 'belen',
  },
  {
    nombre: 'Belén de Los Andaquíes',
    codigo: '18.094',
    departamento: 'Caquetá',
    normalizada: 'belendelosandaquies',
  },
  {
    nombre: 'Belén de Umbría',
    codigo: '66.088',
    departamento: 'Risaralda',
    normalizada: 'belendeumbria',
  },
  {
    nombre: 'Bello',
    codigo: '5.088',
    departamento: 'Antioquia',
    normalizada: 'bello',
  },
  {
    nombre: 'Belmira',
    codigo: '5.086',
    departamento: 'Antioquia',
    normalizada: 'belmira',
  },
  {
    nombre: 'Beltrán',
    codigo: '25.086',
    departamento: 'Cundinamarca',
    normalizada: 'beltran',
  },
  {
    nombre: 'Berbeo',
    codigo: '15.09',
    departamento: 'Boyacá',
    normalizada: 'berbeo',
  },
  {
    nombre: 'Betania',
    codigo: '5.091',
    departamento: 'Antioquia',
    normalizada: 'betania',
  },
  {
    nombre: 'Betéitiva',
    codigo: '15.092',
    departamento: 'Boyacá',
    normalizada: 'beteitiva',
  },
  {
    nombre: 'Betulia',
    codigo: '5.093',
    departamento: 'Antioquia',
    normalizada: 'betulia',
  },
  {
    nombre: 'Betulia',
    codigo: '68.092',
    departamento: 'Santander',
    normalizada: 'betulia',
  },
  {
    nombre: 'Bituima',
    codigo: '25.095',
    departamento: 'Cundinamarca',
    normalizada: 'bituima',
  },
  {
    nombre: 'Boavita',
    codigo: '15.097',
    departamento: 'Boyacá',
    normalizada: 'boavita',
  },
  {
    nombre: 'Bochalema',
    codigo: '54.099',
    departamento: 'Norte de Santander',
    normalizada: 'bochalema',
  },
  {
    nombre: 'Bogotá',
    codigo: '11.001',
    departamento: 'Bogotá',
    normalizada: 'bogota',
  },
  {
    nombre: 'Bojacá',
    codigo: '25.099',
    departamento: 'Cundinamarca',
    normalizada: 'bojaca',
  },
  {
    nombre: 'Bojayá',
    codigo: '27.099',
    departamento: 'Chocó',
    normalizada: 'bojaya',
  },
  {
    nombre: 'Bolívar',
    codigo: '19.1',
    departamento: 'Cauca',
    normalizada: 'bolivar',
  },
  {
    nombre: 'Bolívar',
    codigo: '68.101',
    departamento: 'Santander',
    normalizada: 'bolivar',
  },
  {
    nombre: 'Bolívar',
    codigo: '76.1',
    departamento: 'Valle del Cauca',
    normalizada: 'bolivar',
  },
  {
    nombre: 'Bosconia',
    codigo: '20.06',
    departamento: 'Cesár',
    normalizada: 'bosconia',
  },
  {
    nombre: 'Boyacá',
    codigo: '15.104',
    departamento: 'Boyacá',
    normalizada: 'boyaca',
  },
  {
    nombre: 'Briceño',
    codigo: '5.107',
    departamento: 'Antioquia',
    normalizada: 'briceno',
  },
  {
    nombre: 'Briceño',
    codigo: '15.106',
    departamento: 'Boyacá',
    normalizada: 'briceno',
  },
  {
    nombre: 'Bucaramanga',
    codigo: '68.001',
    departamento: 'Santander',
    normalizada: 'bucaramanga',
  },
  {
    nombre: 'Bucarasica',
    codigo: '54.109',
    departamento: 'Norte de Santander',
    normalizada: 'bucarasica',
  },
  {
    nombre: 'Buena Vista',
    codigo: '15.109',
    departamento: 'Boyacá',
    normalizada: 'buenavista',
  },
  {
    nombre: 'Buenaventura',
    codigo: '76.109',
    departamento: 'Valle del Cauca',
    normalizada: 'buenaventura',
  },
  {
    nombre: 'Buenavista',
    codigo: '23.079',
    departamento: 'Córdoba',
    normalizada: 'buenavista',
  },
  {
    nombre: 'Buenavista',
    codigo: '63.111',
    departamento: 'Quindío',
    normalizada: 'buenavista',
  },
  {
    nombre: 'Buenavista',
    codigo: '70.11',
    departamento: 'Sucre',
    normalizada: 'buenavista',
  },
  {
    nombre: 'Buenos Aires',
    codigo: '19.11',
    departamento: 'Cauca',
    normalizada: 'buenosaires',
  },
  {
    nombre: 'Buesaco',
    codigo: '52.11',
    departamento: 'Nariño',
    normalizada: 'buesaco',
  },
  {
    nombre: 'Bugalagrande',
    codigo: '76.113',
    departamento: 'Valle del Cauca',
    normalizada: 'bugalagrande',
  },
  {
    nombre: 'Buriticá',
    codigo: '5.113',
    departamento: 'Antioquia',
    normalizada: 'buritica',
  },
  {
    nombre: 'Busbanzá',
    codigo: '15.114',
    departamento: 'Boyacá',
    normalizada: 'busbanza',
  },
  {
    nombre: 'Cabrera',
    codigo: '25.12',
    departamento: 'Cundinamarca',
    normalizada: 'cabrera',
  },
  {
    nombre: 'Cabrera',
    codigo: '68.121',
    departamento: 'Santander',
    normalizada: 'cabrera',
  },
  {
    nombre: 'Cabuyaro',
    codigo: '50.124',
    departamento: 'Meta',
    normalizada: 'cabuyaro',
  },
  {
    nombre: 'Cacahual',
    codigo: '94.886',
    departamento: 'Guainía',
    normalizada: 'cacahual',
  },
  {
    nombre: 'Cáceres',
    codigo: '5.12',
    departamento: 'Antioquia',
    normalizada: 'caceres',
  },
  {
    nombre: 'Cachipay',
    codigo: '25.123',
    departamento: 'Cundinamarca',
    normalizada: 'cachipay',
  },
  {
    nombre: 'Cáchira',
    codigo: '54.128',
    departamento: 'Norte de Santander',
    normalizada: 'cachira',
  },
  {
    nombre: 'Cácota',
    codigo: '54.125',
    departamento: 'Norte de Santander',
    normalizada: 'cacota',
  },
  {
    nombre: 'Caicedo',
    codigo: '5.125',
    departamento: 'Antioquia',
    normalizada: 'caicedo',
  },
  {
    nombre: 'Caicedonia',
    codigo: '76.122',
    departamento: 'Valle del Cauca',
    normalizada: 'caicedonia',
  },
  {
    nombre: 'Caimito',
    codigo: '70.124',
    departamento: 'Sucre',
    normalizada: 'caimito',
  },
  {
    nombre: 'Cajamarca',
    codigo: '73.124',
    departamento: 'Tolima',
    normalizada: 'cajamarca',
  },
  {
    nombre: 'Cajibío',
    codigo: '19.13',
    departamento: 'Cauca',
    normalizada: 'cajibio',
  },
  {
    nombre: 'Cajicá',
    codigo: '25.126',
    departamento: 'Cundinamarca',
    normalizada: 'cajica',
  },
  {
    nombre: 'Calamar',
    codigo: '13.14',
    departamento: 'Bolívar',
    normalizada: 'calamar',
  },
  {
    nombre: 'Calamar',
    codigo: '95.015',
    departamento: 'Guaviare',
    normalizada: 'calamar',
  },
  {
    nombre: 'Calarcá',
    codigo: '63.13',
    departamento: 'Quindío',
    normalizada: 'calarca',
  },
  {
    nombre: 'Caldas',
    codigo: '5.129',
    departamento: 'Antioquia',
    normalizada: 'caldas',
  },
  {
    nombre: 'Caldas',
    codigo: '15.131',
    departamento: 'Boyacá',
    normalizada: 'caldas',
  },
  {
    nombre: 'Caldono',
    codigo: '19.137',
    departamento: 'Cauca',
    normalizada: 'caldono',
  },
  {
    nombre: 'Cali',
    codigo: '76.001',
    departamento: 'Valle del Cauca',
    normalizada: 'cali',
  },
  {
    nombre: 'California',
    codigo: '68.132',
    departamento: 'Santander',
    normalizada: 'california',
  },
  {
    nombre: 'Calima',
    codigo: '76.126',
    departamento: 'Valle del Cauca',
    normalizada: 'calima',
  },
  {
    nombre: 'Caloto',
    codigo: '19.142',
    departamento: 'Cauca',
    normalizada: 'caloto',
  },
  {
    nombre: 'Campamento',
    codigo: '5.134',
    departamento: 'Antioquia',
    normalizada: 'campamento',
  },
  {
    nombre: 'Campo de La Cruz',
    codigo: '8.137',
    departamento: 'Atlántico',
    normalizada: 'campodelacruz',
  },
  {
    nombre: 'Campoalegre',
    codigo: '41.132',
    departamento: 'Huila',
    normalizada: 'campoalegre',
  },
  {
    nombre: 'Campohermoso',
    codigo: '15.135',
    departamento: 'Boyacá',
    normalizada: 'campohermoso',
  },
  {
    nombre: 'Canalete',
    codigo: '23.09',
    departamento: 'Córdoba',
    normalizada: 'canalete',
  },
  {
    nombre: 'Candelaria',
    codigo: '8.141',
    departamento: 'Atlántico',
    normalizada: 'candelaria',
  },
  {
    nombre: 'Candelaria',
    codigo: '76.13',
    departamento: 'Valle del Cauca',
    normalizada: 'candelaria',
  },
  {
    nombre: 'Cantagallo',
    codigo: '13.16',
    departamento: 'Bolívar',
    normalizada: 'cantagallo',
  },
  {
    nombre: 'Cañasgordas',
    codigo: '5.138',
    departamento: 'Antioquia',
    normalizada: 'canasgordas',
  },
  {
    nombre: 'Caparrapí',
    codigo: '25.148',
    departamento: 'Cundinamarca',
    normalizada: 'caparrapi',
  },
  {
    nombre: 'Capitanejo',
    codigo: '68.147',
    departamento: 'Santander',
    normalizada: 'capitanejo',
  },
  {
    nombre: 'Cáqueza',
    codigo: '25.151',
    departamento: 'Cundinamarca',
    normalizada: 'caqueza',
  },
  {
    nombre: 'Caracolí',
    codigo: '5.142',
    departamento: 'Antioquia',
    normalizada: 'caracoli',
  },
  {
    nombre: 'Caramanta',
    codigo: '5.145',
    departamento: 'Antioquia',
    normalizada: 'caramanta',
  },
  {
    nombre: 'Carcasí',
    codigo: '68.152',
    departamento: 'Santander',
    normalizada: 'carcasi',
  },
  {
    nombre: 'Carepa',
    codigo: '5.147',
    departamento: 'Antioquia',
    normalizada: 'carepa',
  },
  {
    nombre: 'Carmen de Apicalá',
    codigo: '73.148',
    departamento: 'Tolima',
    normalizada: 'carmendeapicala',
  },
  {
    nombre: 'Carmen de Carupa',
    codigo: '25.154',
    departamento: 'Cundinamarca',
    normalizada: 'carmendecarupa',
  },
  {
    nombre: 'Carmen del Darién',
    codigo: '27.15',
    departamento: 'Chocó',
    normalizada: 'carmendeldarien',
  },
  {
    nombre: 'Carolina',
    codigo: '5.15',
    departamento: 'Antioquia',
    normalizada: 'carolina',
  },
  {
    nombre: 'Cartagena',
    codigo: '13.001',
    departamento: 'Bolívar',
    normalizada: 'cartagena',
  },
  {
    nombre: 'Cartagena del Chairá',
    codigo: '18.15',
    departamento: 'Caquetá',
    normalizada: 'cartagenadelchaira',
  },
  {
    nombre: 'Cartago',
    codigo: '76.147',
    departamento: 'Valle del Cauca',
    normalizada: 'cartago',
  },
  {
    nombre: 'Carurú',
    codigo: '97.161',
    departamento: 'Vaupés',
    normalizada: 'caruru',
  },
  {
    nombre: 'Casabianca',
    codigo: '73.152',
    departamento: 'Tolima',
    normalizada: 'casabianca',
  },
  {
    nombre: 'Castilla la Nueva',
    codigo: '50.15',
    departamento: 'Meta',
    normalizada: 'castillalanueva',
  },
  {
    nombre: 'Caucasia',
    codigo: '5.154',
    departamento: 'Antioquia',
    normalizada: 'caucasia',
  },
  {
    nombre: 'Cepitá',
    codigo: '68.16',
    departamento: 'Santander',
    normalizada: 'cepita',
  },
  {
    nombre: 'Cereté',
    codigo: '23.162',
    departamento: 'Córdoba',
    normalizada: 'cerete',
  },
  {
    nombre: 'Cerinza',
    codigo: '15.162',
    departamento: 'Boyacá',
    normalizada: 'cerinza',
  },
  {
    nombre: 'Cerrito',
    codigo: '68.162',
    departamento: 'Santander',
    normalizada: 'cerrito',
  },
  {
    nombre: 'Cerro de San Antonio',
    codigo: '47.161',
    departamento: 'Magdalena',
    normalizada: 'cerrodesanantonio',
  },
  {
    nombre: 'Cértegui',
    codigo: '27.16',
    departamento: 'Chocó',
    normalizada: 'certegui',
  },
  {
    nombre: 'Chachagüí',
    codigo: '52.24',
    departamento: 'Nariño',
    normalizada: 'chachagui',
  },
  {
    nombre: 'Chaguaní',
    codigo: '25.168',
    departamento: 'Cundinamarca',
    normalizada: 'chaguani',
  },
  {
    nombre: 'Chalán',
    codigo: '70.23',
    departamento: 'Sucre',
    normalizada: 'chalan',
  },
  {
    nombre: 'Chámeza',
    codigo: '85.015',
    departamento: 'Casanare',
    normalizada: 'chameza',
  },
  {
    nombre: 'Chaparral',
    codigo: '73.168',
    departamento: 'Tolima',
    normalizada: 'chaparral',
  },
  {
    nombre: 'Charalá',
    codigo: '68.167',
    departamento: 'Santander',
    normalizada: 'charala',
  },
  {
    nombre: 'Charta',
    codigo: '68.169',
    departamento: 'Santander',
    normalizada: 'charta',
  },
  {
    nombre: 'Chía',
    codigo: '25.175',
    departamento: 'Cundinamarca',
    normalizada: 'chia',
  },
  {
    nombre: 'Chigorodó',
    codigo: '5.172',
    departamento: 'Antioquia',
    normalizada: 'chigorodo',
  },
  {
    nombre: 'Chimá',
    codigo: '23.168',
    departamento: 'Córdoba',
    normalizada: 'chima',
  },
  {
    nombre: 'Chimá',
    codigo: '68.176',
    departamento: 'Santander',
    normalizada: 'chima',
  },
  {
    nombre: 'Chimichagua',
    codigo: '20.175',
    departamento: 'Cesár',
    normalizada: 'chimichagua',
  },
  {
    nombre: 'Chinácota',
    codigo: '54.172',
    departamento: 'Norte de Santander',
    normalizada: 'chinacota',
  },
  {
    nombre: 'Chinavita',
    codigo: '15.172',
    departamento: 'Boyacá',
    normalizada: 'chinavita',
  },
  {
    nombre: 'Chinchiná',
    codigo: '17.174',
    departamento: 'Caldas',
    normalizada: 'chinchina',
  },
  {
    nombre: 'Chinú',
    codigo: '23.182',
    departamento: 'Córdoba',
    normalizada: 'chinu',
  },
  {
    nombre: 'Chipaque',
    codigo: '25.178',
    departamento: 'Cundinamarca',
    normalizada: 'chipaque',
  },
  {
    nombre: 'Chipatá',
    codigo: '68.179',
    departamento: 'Santander',
    normalizada: 'chipata',
  },
  {
    nombre: 'Chiquinquirá',
    codigo: '15.176',
    departamento: 'Boyacá',
    normalizada: 'chiquinquira',
  },
  {
    nombre: 'Chíquiza',
    codigo: '15.232',
    departamento: 'Boyacá',
    normalizada: 'chiquiza',
  },
  {
    nombre: 'Chiriguaná',
    codigo: '20.178',
    departamento: 'Cesár',
    normalizada: 'chiriguana',
  },
  {
    nombre: 'Chiscas',
    codigo: '15.18',
    departamento: 'Boyacá',
    normalizada: 'chiscas',
  },
  {
    nombre: 'Chita',
    codigo: '15.183',
    departamento: 'Boyacá',
    normalizada: 'chita',
  },
  {
    nombre: 'Chitagá',
    codigo: '54.174',
    departamento: 'Norte de Santander',
    normalizada: 'chitaga',
  },
  {
    nombre: 'Chitaraque',
    codigo: '15.185',
    departamento: 'Boyacá',
    normalizada: 'chitaraque',
  },
  {
    nombre: 'Chivatá',
    codigo: '15.187',
    departamento: 'Boyacá',
    normalizada: 'chivata',
  },
  {
    nombre: 'Chivolo',
    codigo: '47.17',
    departamento: 'Magdalena',
    normalizada: 'chivolo',
  },
  {
    nombre: 'Chivor',
    codigo: '15.236',
    departamento: 'Boyacá',
    normalizada: 'chivor',
  },
  {
    nombre: 'Choachí',
    codigo: '25.181',
    departamento: 'Cundinamarca',
    normalizada: 'choachi',
  },
  {
    nombre: 'Chocontá',
    codigo: '25.183',
    departamento: 'Cundinamarca',
    normalizada: 'choconta',
  },
  {
    nombre: 'Cicuco',
    codigo: '13.188',
    departamento: 'Bolívar',
    normalizada: 'cicuco',
  },
  {
    nombre: 'Ciénaga',
    codigo: '47.189',
    departamento: 'Magdalena',
    normalizada: 'cienaga',
  },
  {
    nombre: 'Ciénaga de Oro',
    codigo: '23.189',
    departamento: 'Córdoba',
    normalizada: 'cienagadeoro',
  },
  {
    nombre: 'Ciénega',
    codigo: '15.189',
    departamento: 'Boyacá',
    normalizada: 'cienega',
  },
  {
    nombre: 'Cimitarra',
    codigo: '68.19',
    departamento: 'Santander',
    normalizada: 'cimitarra',
  },
  {
    nombre: 'Circasia',
    codigo: '63.19',
    departamento: 'Quindío',
    normalizada: 'circasia',
  },
  {
    nombre: 'Cisneros',
    codigo: '5.19',
    departamento: 'Antioquia',
    normalizada: 'cisneros',
  },
  {
    nombre: 'Ciudad Bolívar',
    codigo: '5.101',
    departamento: 'Antioquia',
    normalizada: 'ciudadbolivar',
  },
  {
    nombre: 'Clemencia',
    codigo: '13.222',
    departamento: 'Bolívar',
    normalizada: 'clemencia',
  },
  {
    nombre: 'Cocorná',
    codigo: '5.197',
    departamento: 'Antioquia',
    normalizada: 'cocorna',
  },
  {
    nombre: 'Coello',
    codigo: '73.2',
    departamento: 'Tolima',
    normalizada: 'coello',
  },
  {
    nombre: 'Cogua',
    codigo: '25.2',
    departamento: 'Cundinamarca',
    normalizada: 'cogua',
  },
  {
    nombre: 'Colombia',
    codigo: '41.206',
    departamento: 'Huila',
    normalizada: 'colombia',
  },
  {
    nombre: 'Colón',
    codigo: '52.203',
    departamento: 'Nariño',
    normalizada: 'colon',
  },
  {
    nombre: 'Colón',
    codigo: '86.219',
    departamento: 'Putumayo',
    normalizada: 'colon',
  },
  {
    nombre: 'Colosó',
    codigo: '70.204',
    departamento: 'Sucre',
    normalizada: 'coloso',
  },
  {
    nombre: 'Cómbita',
    codigo: '15.204',
    departamento: 'Boyacá',
    normalizada: 'combita',
  },
  {
    nombre: 'Concepción',
    codigo: '5.206',
    departamento: 'Antioquia',
    normalizada: 'concepcion',
  },
  {
    nombre: 'Concepción',
    codigo: '68.207',
    departamento: 'Santander',
    normalizada: 'concepcion',
  },
  {
    nombre: 'Concordia',
    codigo: '5.209',
    departamento: 'Antioquia',
    normalizada: 'concordia',
  },
  {
    nombre: 'Concordia',
    codigo: '47.205',
    departamento: 'Magdalena',
    normalizada: 'concordia',
  },
  {
    nombre: 'Condoto',
    codigo: '27.205',
    departamento: 'Chocó',
    normalizada: 'condoto',
  },
  {
    nombre: 'Confines',
    codigo: '68.209',
    departamento: 'Santander',
    normalizada: 'confines',
  },
  {
    nombre: 'Consacá',
    codigo: '52.207',
    departamento: 'Nariño',
    normalizada: 'consaca',
  },
  {
    nombre: 'Contadero',
    codigo: '52.21',
    departamento: 'Nariño',
    normalizada: 'contadero',
  },
  {
    nombre: 'Contratación',
    codigo: '68.211',
    departamento: 'Santander',
    normalizada: 'contratacion',
  },
  {
    nombre: 'Convención',
    codigo: '54.206',
    departamento: 'Norte de Santander',
    normalizada: 'convencion',
  },
  {
    nombre: 'Copacabana',
    codigo: '5.212',
    departamento: 'Antioquia',
    normalizada: 'copacabana',
  },
  {
    nombre: 'Coper',
    codigo: '15.212',
    departamento: 'Boyacá',
    normalizada: 'coper',
  },
  {
    nombre: 'Córdoba',
    codigo: '13.212',
    departamento: 'Bolívar',
    normalizada: 'cordoba',
  },
  {
    nombre: 'Córdoba',
    codigo: '52.215',
    departamento: 'Nariño',
    normalizada: 'cordoba',
  },
  {
    nombre: 'Córdoba',
    codigo: '63.212',
    departamento: 'Quindío',
    normalizada: 'cordoba',
  },
  {
    nombre: 'Corinto',
    codigo: '19.212',
    departamento: 'Cauca',
    normalizada: 'corinto',
  },
  {
    nombre: 'Coromoro',
    codigo: '68.217',
    departamento: 'Santander',
    normalizada: 'coromoro',
  },
  {
    nombre: 'Corozal',
    codigo: '70.215',
    departamento: 'Sucre',
    normalizada: 'corozal',
  },
  {
    nombre: 'Corrales',
    codigo: '15.215',
    departamento: 'Boyacá',
    normalizada: 'corrales',
  },
  {
    nombre: 'Cota',
    codigo: '25.214',
    departamento: 'Cundinamarca',
    normalizada: 'cota',
  },
  {
    nombre: 'Cotorra',
    codigo: '23.3',
    departamento: 'Córdoba',
    normalizada: 'cotorra',
  },
  {
    nombre: 'Covarachía',
    codigo: '15.218',
    departamento: 'Boyacá',
    normalizada: 'covarachia',
  },
  {
    nombre: 'Coveñas',
    codigo: '70.221',
    departamento: 'Sucre',
    normalizada: 'covenas',
  },
  {
    nombre: 'Coyaima',
    codigo: '73.217',
    departamento: 'Tolima',
    normalizada: 'coyaima',
  },
  {
    nombre: 'Cravo Norte',
    codigo: '81.22',
    departamento: 'Arauca',
    normalizada: 'cravonorte',
  },
  {
    nombre: 'Cuaspud Carlosama',
    codigo: '52.224',
    departamento: 'Nariño',
    normalizada: 'cuaspudcarlosama',
  },
  {
    nombre: 'Cubará',
    codigo: '15.223',
    departamento: 'Boyacá',
    normalizada: 'cubara',
  },
  {
    nombre: 'Cubarral',
    codigo: '50.223',
    departamento: 'Meta',
    normalizada: 'cubarral',
  },
  {
    nombre: 'Cucaita',
    codigo: '15.224',
    departamento: 'Boyacá',
    normalizada: 'cucaita',
  },
  {
    nombre: 'Cucunubá',
    codigo: '25.224',
    departamento: 'Cundinamarca',
    normalizada: 'cucunuba',
  },
  {
    nombre: 'Cúcuta',
    codigo: '54.001',
    departamento: 'Norte de Santander',
    normalizada: 'cucuta',
  },
  {
    nombre: 'Cucutilla',
    codigo: '54.223',
    departamento: 'Norte de Santander',
    normalizada: 'cucutilla',
  },
  {
    nombre: 'Cuítiva',
    codigo: '15.226',
    departamento: 'Boyacá',
    normalizada: 'cuitiva',
  },
  {
    nombre: 'Cumaral',
    codigo: '50.226',
    departamento: 'Meta',
    normalizada: 'cumaral',
  },
  {
    nombre: 'Cumaribo',
    codigo: '99.773',
    departamento: 'Vichada',
    normalizada: 'cumaribo',
  },
  {
    nombre: 'Cumbal',
    codigo: '52.227',
    departamento: 'Nariño',
    normalizada: 'cumbal',
  },
  {
    nombre: 'Cumbitara',
    codigo: '52.233',
    departamento: 'Nariño',
    normalizada: 'cumbitara',
  },
  {
    nombre: 'Cunday',
    codigo: '73.226',
    departamento: 'Tolima',
    normalizada: 'cunday',
  },
  {
    nombre: 'Curillo',
    codigo: '18.205',
    departamento: 'Caquetá',
    normalizada: 'curillo',
  },
  {
    nombre: 'Curití',
    codigo: '68.229',
    departamento: 'Santander',
    normalizada: 'curiti',
  },
  {
    nombre: 'Curumaní',
    codigo: '20.228',
    departamento: 'Cesár',
    normalizada: 'curumani',
  },
  {
    nombre: 'Dabeiba',
    codigo: '5.234',
    departamento: 'Antioquia',
    normalizada: 'dabeiba',
  },
  {
    nombre: 'Dagua',
    codigo: '76.233',
    departamento: 'Valle del Cauca',
    normalizada: 'dagua',
  },
  {
    nombre: 'Dibulla',
    codigo: '44.09',
    departamento: 'La Guajira',
    normalizada: 'dibulla',
  },
  {
    nombre: 'Distracción',
    codigo: '44.098',
    departamento: 'La Guajira',
    normalizada: 'distraccion',
  },
  {
    nombre: 'Dolores',
    codigo: '73.236',
    departamento: 'Tolima',
    normalizada: 'dolores',
  },
  {
    nombre: 'Don Matías',
    codigo: '5.237',
    departamento: 'Antioquia',
    normalizada: 'donmatias',
  },
  {
    nombre: 'Dosquebradas',
    codigo: '66.17',
    departamento: 'Risaralda',
    normalizada: 'dosquebradas',
  },
  {
    nombre: 'Duitama',
    codigo: '15.238',
    departamento: 'Boyacá',
    normalizada: 'duitama',
  },
  {
    nombre: 'Durania',
    codigo: '54.239',
    departamento: 'Norte de Santander',
    normalizada: 'durania',
  },
  {
    nombre: 'Ebéjico',
    codigo: '5.24',
    departamento: 'Antioquia',
    normalizada: 'ebejico',
  },
  {
    nombre: 'El Águila',
    codigo: '76.243',
    departamento: 'Valle del Cauca',
    normalizada: 'elaguila',
  },
  {
    nombre: 'El Bagre',
    codigo: '5.25',
    departamento: 'Antioquia',
    normalizada: 'elbagre',
  },
  {
    nombre: 'El Banco',
    codigo: '47.245',
    departamento: 'Magdalena',
    normalizada: 'elbanco',
  },
  {
    nombre: 'El Cairo',
    codigo: '76.246',
    departamento: 'Valle del Cauca',
    normalizada: 'elcairo',
  },
  {
    nombre: 'El Calvario',
    codigo: '50.245',
    departamento: 'Meta',
    normalizada: 'elcalvario',
  },
  {
    nombre: 'El Cantón del San Pablo',
    codigo: '27.135',
    departamento: 'Chocó',
    normalizada: 'elcantondelsanpablo',
  },
  {
    nombre: 'El Carmen',
    codigo: '54.245',
    departamento: 'Norte de Santander',
    normalizada: 'elcarmen',
  },
  {
    nombre: 'El Carmen de Atrato',
    codigo: '27.245',
    departamento: 'Chocó',
    normalizada: 'elcarmendeatrato',
  },
  {
    nombre: 'El Carmen de Bolívar',
    codigo: '13.244',
    departamento: 'Bolívar',
    normalizada: 'elcarmendebolivar',
  },
  {
    nombre: 'El Carmen de Chucurí',
    codigo: '68.235',
    departamento: 'Santander',
    normalizada: 'elcarmendechucuri',
  },
  {
    nombre: 'El Carmen de Viboral',
    codigo: '5.148',
    departamento: 'Antioquia',
    normalizada: 'elcarmendeviboral',
  },
  {
    nombre: 'El Castillo',
    codigo: '50.251',
    departamento: 'Meta',
    normalizada: 'elcastillo',
  },
  {
    nombre: 'El Cerrito',
    codigo: '76.248',
    departamento: 'Valle del Cauca',
    normalizada: 'elcerrito',
  },
  {
    nombre: 'El Charco',
    codigo: '52.25',
    departamento: 'Nariño',
    normalizada: 'elcharco',
  },
  {
    nombre: 'El Cocuy',
    codigo: '15.244',
    departamento: 'Boyacá',
    normalizada: 'elcocuy',
  },
  {
    nombre: 'El Colegio',
    codigo: '25.245',
    departamento: 'Cundinamarca',
    normalizada: 'elcolegio',
  },
  {
    nombre: 'El Copey',
    codigo: '20.238',
    departamento: 'Cesár',
    normalizada: 'elcopey',
  },
  {
    nombre: 'El Doncello',
    codigo: '18.247',
    departamento: 'Caquetá',
    normalizada: 'eldoncello',
  },
  {
    nombre: 'El Dorado',
    codigo: '50.27',
    departamento: 'Meta',
    normalizada: 'eldorado',
  },
  {
    nombre: 'El Dovio',
    codigo: '76.25',
    departamento: 'Valle del Cauca',
    normalizada: 'eldovio',
  },
  {
    nombre: 'El Encanto',
    codigo: '91.263',
    departamento: 'Amazonas',
    normalizada: 'elencanto',
  },
  {
    nombre: 'El Espino',
    codigo: '15.248',
    departamento: 'Boyacá',
    normalizada: 'elespino',
  },
  {
    nombre: 'El Guacamayo',
    codigo: '68.245',
    departamento: 'Santander',
    normalizada: 'elguacamayo',
  },
  {
    nombre: 'El Guamo',
    codigo: '13.248',
    departamento: 'Bolívar',
    normalizada: 'elguamo',
  },
  {
    nombre: 'El Litoral del San Juan',
    codigo: '27.25',
    departamento: 'Chocó',
    normalizada: 'ellitoraldelsanjuan',
  },
  {
    nombre: 'El Molino',
    codigo: '44.11',
    departamento: 'La Guajira',
    normalizada: 'elmolino',
  },
  {
    nombre: 'El Paso',
    codigo: '20.25',
    departamento: 'Cesár',
    normalizada: 'elpaso',
  },
  {
    nombre: 'El Paujil',
    codigo: '18.256',
    departamento: 'Caquetá',
    normalizada: 'elpaujil',
  },
  {
    nombre: 'El Peñol',
    codigo: '52.254',
    departamento: 'Nariño',
    normalizada: 'elpenol',
  },
  {
    nombre: 'El Peñón',
    codigo: '13.268',
    departamento: 'Bolívar',
    normalizada: 'elpenon',
  },
  {
    nombre: 'El Peñón',
    codigo: '25.258',
    departamento: 'Cundinamarca',
    normalizada: 'elpenon',
  },
  {
    nombre: 'El Peñón',
    codigo: '68.25',
    departamento: 'Santander',
    normalizada: 'elpenon',
  },
  {
    nombre: 'El Piñón',
    codigo: '47.258',
    departamento: 'Magdalena',
    normalizada: 'elpinon',
  },
  {
    nombre: 'El Playón',
    codigo: '68.255',
    departamento: 'Santander',
    normalizada: 'elplayon',
  },
  {
    nombre: 'El Retén',
    codigo: '47.268',
    departamento: 'Magdalena',
    normalizada: 'elreten',
  },
  {
    nombre: 'El Retorno',
    codigo: '95.025',
    departamento: 'Guaviare',
    normalizada: 'elretorno',
  },
  {
    nombre: 'El Roble',
    codigo: '70.233',
    departamento: 'Sucre',
    normalizada: 'elroble',
  },
  {
    nombre: 'El Rosal',
    codigo: '25.26',
    departamento: 'Cundinamarca',
    normalizada: 'elrosal',
  },
  {
    nombre: 'El Rosario',
    codigo: '52.256',
    departamento: 'Nariño',
    normalizada: 'elrosario',
  },
  {
    nombre: 'El Santuario',
    codigo: '5.697',
    departamento: 'Antioquia',
    normalizada: 'elsantuario',
  },
  {
    nombre: 'El Tablón de Gómez',
    codigo: '52.258',
    departamento: 'Nariño',
    normalizada: 'eltablondegomez',
  },
  {
    nombre: 'El Tambo',
    codigo: '19.256',
    departamento: 'Cauca',
    normalizada: 'eltambo',
  },
  {
    nombre: 'El Tambo',
    codigo: '52.26',
    departamento: 'Nariño',
    normalizada: 'eltambo',
  },
  {
    nombre: 'El Tarra',
    codigo: '54.25',
    departamento: 'Norte de Santander',
    normalizada: 'eltarra',
  },
  {
    nombre: 'El Zulia',
    codigo: '54.261',
    departamento: 'Norte de Santander',
    normalizada: 'elzulia',
  },
  {
    nombre: 'Elías',
    codigo: '41.244',
    departamento: 'Huila',
    normalizada: 'elias',
  },
  {
    nombre: 'Encino',
    codigo: '68.264',
    departamento: 'Santander',
    normalizada: 'encino',
  },
  {
    nombre: 'Enciso',
    codigo: '68.266',
    departamento: 'Santander',
    normalizada: 'enciso',
  },
  {
    nombre: 'Entrerríos',
    codigo: '5.264',
    departamento: 'Antioquia',
    normalizada: 'entrerrios',
  },
  {
    nombre: 'Envigado',
    codigo: '5.266',
    departamento: 'Antioquia',
    normalizada: 'envigado',
  },
  {
    nombre: 'Espinal',
    codigo: '73.268',
    departamento: 'Tolima',
    normalizada: 'espinal',
  },
  {
    nombre: 'Facatativá',
    codigo: '25.269',
    departamento: 'Cundinamarca',
    normalizada: 'facatativa',
  },
  {
    nombre: 'Falan',
    codigo: '73.27',
    departamento: 'Tolima',
    normalizada: 'falan',
  },
  {
    nombre: 'Filadelfia',
    codigo: '17.272',
    departamento: 'Caldas',
    normalizada: 'filadelfia',
  },
  {
    nombre: 'Filandia',
    codigo: '63.272',
    departamento: 'Quindío',
    normalizada: 'filandia',
  },
  {
    nombre: 'Firavitoba',
    codigo: '15.272',
    departamento: 'Boyacá',
    normalizada: 'firavitoba',
  },
  {
    nombre: 'Flandes',
    codigo: '73.275',
    departamento: 'Tolima',
    normalizada: 'flandes',
  },
  {
    nombre: 'Florencia',
    codigo: '18.001',
    departamento: 'Caquetá',
    normalizada: 'florencia',
  },
  {
    nombre: 'Florencia',
    codigo: '19.29',
    departamento: 'Cauca',
    normalizada: 'florencia',
  },
  {
    nombre: 'Floresta',
    codigo: '15.276',
    departamento: 'Boyacá',
    normalizada: 'floresta',
  },
  {
    nombre: 'Florián',
    codigo: '68.271',
    departamento: 'Santander',
    normalizada: 'florian',
  },
  {
    nombre: 'Florida',
    codigo: '76.275',
    departamento: 'Valle del Cauca',
    normalizada: 'florida',
  },
  {
    nombre: 'Floridablanca',
    codigo: '68.276',
    departamento: 'Santander',
    normalizada: 'floridablanca',
  },
  {
    nombre: 'Fómeque',
    codigo: '25.279',
    departamento: 'Cundinamarca',
    normalizada: 'fomeque',
  },
  {
    nombre: 'Fonseca',
    codigo: '44.279',
    departamento: 'La Guajira',
    normalizada: 'fonseca',
  },
  {
    nombre: 'Fortul',
    codigo: '81.3',
    departamento: 'Arauca',
    normalizada: 'fortul',
  },
  {
    nombre: 'Fosca',
    codigo: '25.281',
    departamento: 'Cundinamarca',
    normalizada: 'fosca',
  },
  {
    nombre: 'Francisco Pizarro',
    codigo: '52.52',
    departamento: 'Nariño',
    normalizada: 'franciscopizarro',
  },
  {
    nombre: 'Fredonia',
    codigo: '5.282',
    departamento: 'Antioquia',
    normalizada: 'fredonia',
  },
  {
    nombre: 'Fresno',
    codigo: '73.283',
    departamento: 'Tolima',
    normalizada: 'fresno',
  },
  {
    nombre: 'Frontino',
    codigo: '5.284',
    departamento: 'Antioquia',
    normalizada: 'frontino',
  },
  {
    nombre: 'Fuente de Oro',
    codigo: '50.287',
    departamento: 'Meta',
    normalizada: 'fuentedeoro',
  },
  {
    nombre: 'Fundación',
    codigo: '47.288',
    departamento: 'Magdalena',
    normalizada: 'fundacion',
  },
  {
    nombre: 'Funes',
    codigo: '52.287',
    departamento: 'Nariño',
    normalizada: 'funes',
  },
  {
    nombre: 'Funza',
    codigo: '25.286',
    departamento: 'Cundinamarca',
    normalizada: 'funza',
  },
  {
    nombre: 'Fúquene',
    codigo: '25.288',
    departamento: 'Cundinamarca',
    normalizada: 'fuquene',
  },
  {
    nombre: 'Fusagasugá',
    codigo: '25.29',
    departamento: 'Cundinamarca',
    normalizada: 'fusagasuga',
  },
  {
    nombre: 'Gachalá',
    codigo: '25.293',
    departamento: 'Cundinamarca',
    normalizada: 'gachala',
  },
  {
    nombre: 'Gachancipá',
    codigo: '25.295',
    departamento: 'Cundinamarca',
    normalizada: 'gachancipa',
  },
  {
    nombre: 'Gachantivá',
    codigo: '15.293',
    departamento: 'Boyacá',
    normalizada: 'gachantiva',
  },
  {
    nombre: 'Gachetá',
    codigo: '25.297',
    departamento: 'Cundinamarca',
    normalizada: 'gacheta',
  },
  {
    nombre: 'Galán',
    codigo: '68.296',
    departamento: 'Santander',
    normalizada: 'galan',
  },
  {
    nombre: 'Galapa',
    codigo: '8.296',
    departamento: 'Atlántico',
    normalizada: 'galapa',
  },
  {
    nombre: 'Galeras',
    codigo: '70.235',
    departamento: 'Sucre',
    normalizada: 'galeras',
  },
  {
    nombre: 'Gama',
    codigo: '25.299',
    departamento: 'Cundinamarca',
    normalizada: 'gama',
  },
  {
    nombre: 'Gamarra',
    codigo: '20.295',
    departamento: 'Cesár',
    normalizada: 'gamarra',
  },
  {
    nombre: 'Gámbita',
    codigo: '68.298',
    departamento: 'Santander',
    normalizada: 'gambita',
  },
  {
    nombre: 'Gámeza',
    codigo: '15.296',
    departamento: 'Boyacá',
    normalizada: 'gameza',
  },
  {
    nombre: 'Garagoa',
    codigo: '15.299',
    departamento: 'Boyacá',
    normalizada: 'garagoa',
  },
  {
    nombre: 'Garzón',
    codigo: '41.298',
    departamento: 'Huila',
    normalizada: 'garzon',
  },
  {
    nombre: 'Génova',
    codigo: '63.302',
    departamento: 'Quindío',
    normalizada: 'genova',
  },
  {
    nombre: 'Gigante',
    codigo: '41.306',
    departamento: 'Huila',
    normalizada: 'gigante',
  },
  {
    nombre: 'Ginebra',
    codigo: '76.306',
    departamento: 'Valle del Cauca',
    normalizada: 'ginebra',
  },
  {
    nombre: 'Giraldo',
    codigo: '5.306',
    departamento: 'Antioquia',
    normalizada: 'giraldo',
  },
  {
    nombre: 'Girardot',
    codigo: '25.307',
    departamento: 'Cundinamarca',
    normalizada: 'girardot',
  },
  {
    nombre: 'Girardota',
    codigo: '5.308',
    departamento: 'Antioquia',
    normalizada: 'girardota',
  },
  {
    nombre: 'Girón',
    codigo: '68.307',
    departamento: 'Santander',
    normalizada: 'giron',
  },
  {
    nombre: 'Gómez Plata',
    codigo: '5.31',
    departamento: 'Antioquia',
    normalizada: 'gomezplata',
  },
  {
    nombre: 'González',
    codigo: '20.31',
    departamento: 'Cesár',
    normalizada: 'gonzalez',
  },
  {
    nombre: 'Gramalote',
    codigo: '54.313',
    departamento: 'Norte de Santander',
    normalizada: 'gramalote',
  },
  {
    nombre: 'Granada',
    codigo: '25.312',
    departamento: 'Cundinamarca',
    normalizada: 'granada',
  },
  {
    nombre: 'Granada',
    codigo: '50.313',
    departamento: 'Meta',
    normalizada: 'granada',
  },
  {
    nombre: 'Granada',
    codigo: '5.313',
    departamento: 'Antioquia',
    normalizada: 'granada',
  },
  {
    nombre: 'Guaca',
    codigo: '68.318',
    departamento: 'Santander',
    normalizada: 'guaca',
  },
  {
    nombre: 'Guacamayas',
    codigo: '15.317',
    departamento: 'Boyacá',
    normalizada: 'guacamayas',
  },
  {
    nombre: 'Guacarí',
    codigo: '76.318',
    departamento: 'Valle del Cauca',
    normalizada: 'guacari',
  },
  {
    nombre: 'Guachené',
    codigo: '19.3',
    departamento: 'Cauca',
    normalizada: 'guachene',
  },
  {
    nombre: 'Guachetá',
    codigo: '25.317',
    departamento: 'Cundinamarca',
    normalizada: 'guacheta',
  },
  {
    nombre: 'Guachucal',
    codigo: '52.317',
    departamento: 'Nariño',
    normalizada: 'guachucal',
  },
  {
    nombre: 'Guadalajara de Buga',
    codigo: '76.111',
    departamento: 'Valle del Cauca',
    normalizada: 'guadalajaradebuga',
  },
  {
    nombre: 'Guadalupe',
    codigo: '5.315',
    departamento: 'Antioquia',
    normalizada: 'guadalupe',
  },
  {
    nombre: 'Guadalupe',
    codigo: '41.319',
    departamento: 'Huila',
    normalizada: 'guadalupe',
  },
  {
    nombre: 'Guadalupe',
    codigo: '68.32',
    departamento: 'Santander',
    normalizada: 'guadalupe',
  },
  {
    nombre: 'Guaduas',
    codigo: '25.32',
    departamento: 'Cundinamarca',
    normalizada: 'guaduas',
  },
  {
    nombre: 'Guaitarilla',
    codigo: '52.32',
    departamento: 'Nariño',
    normalizada: 'guaitarilla',
  },
  {
    nombre: 'Gualmatán',
    codigo: '52.323',
    departamento: 'Nariño',
    normalizada: 'gualmatan',
  },
  {
    nombre: 'Guamal',
    codigo: '47.318',
    departamento: 'Magdalena',
    normalizada: 'guamal',
  },
  {
    nombre: 'Guamal',
    codigo: '50.318',
    departamento: 'Meta',
    normalizada: 'guamal',
  },
  {
    nombre: 'Guamo',
    codigo: '73.319',
    departamento: 'Tolima',
    normalizada: 'guamo',
  },
  {
    nombre: 'Guapi',
    codigo: '19.318',
    departamento: 'Cauca',
    normalizada: 'guapi',
  },
  {
    nombre: 'Guapotá',
    codigo: '68.322',
    departamento: 'Santander',
    normalizada: 'guapota',
  },
  {
    nombre: 'Guaranda',
    codigo: '70.265',
    departamento: 'Sucre',
    normalizada: 'guaranda',
  },
  {
    nombre: 'Guarne',
    codigo: '5.318',
    departamento: 'Antioquia',
    normalizada: 'guarne',
  },
  {
    nombre: 'Guasca',
    codigo: '25.322',
    departamento: 'Cundinamarca',
    normalizada: 'guasca',
  },
  {
    nombre: 'Guatapé',
    codigo: '5.321',
    departamento: 'Antioquia',
    normalizada: 'guatape',
  },
  {
    nombre: 'Guataquí',
    codigo: '25.324',
    departamento: 'Cundinamarca',
    normalizada: 'guataqui',
  },
  {
    nombre: 'Guatavita',
    codigo: '25.326',
    departamento: 'Cundinamarca',
    normalizada: 'guatavita',
  },
  {
    nombre: 'Guateque',
    codigo: '15.322',
    departamento: 'Boyacá',
    normalizada: 'guateque',
  },
  {
    nombre: 'Guática',
    codigo: '66.318',
    departamento: 'Risaralda',
    normalizada: 'guatica',
  },
  {
    nombre: 'Guavatá',
    codigo: '68.324',
    departamento: 'Santander',
    normalizada: 'guavata',
  },
  {
    nombre: 'Guayabal de Síquima',
    codigo: '25.328',
    departamento: 'Cundinamarca',
    normalizada: 'guayabaldesiquima',
  },
  {
    nombre: 'Guayabetal',
    codigo: '25.335',
    departamento: 'Cundinamarca',
    normalizada: 'guayabetal',
  },
  {
    nombre: 'Guayatá',
    codigo: '15.325',
    departamento: 'Boyacá',
    normalizada: 'guayata',
  },
  {
    nombre: 'Güepsa',
    codigo: '68.327',
    departamento: 'Santander',
    normalizada: 'guepsa',
  },
  {
    nombre: 'Güicán',
    codigo: '15.332',
    departamento: 'Boyacá',
    normalizada: 'guican',
  },
  {
    nombre: 'Gutiérrez',
    codigo: '25.339',
    departamento: 'Cundinamarca',
    normalizada: 'gutierrez',
  },
  {
    nombre: 'Hacarí',
    codigo: '54.344',
    departamento: 'Norte de Santander',
    normalizada: 'hacari',
  },
  {
    nombre: 'Hatillo de Loba',
    codigo: '13.3',
    departamento: 'Bolívar',
    normalizada: 'hatillodeloba',
  },
  {
    nombre: 'Hato',
    codigo: '68.344',
    departamento: 'Santander',
    normalizada: 'hato',
  },
  {
    nombre: 'Hato Corozal',
    codigo: '85.125',
    departamento: 'Casanare',
    normalizada: 'hatocorozal',
  },
  {
    nombre: 'Hatonuevo',
    codigo: '44.378',
    departamento: 'La Guajira',
    normalizada: 'hatonuevo',
  },
  {
    nombre: 'Heliconia',
    codigo: '5.347',
    departamento: 'Antioquia',
    normalizada: 'heliconia',
  },
  {
    nombre: 'Herrán',
    codigo: '54.347',
    departamento: 'Norte de Santander',
    normalizada: 'herran',
  },
  {
    nombre: 'Herveo',
    codigo: '73.347',
    departamento: 'Tolima',
    normalizada: 'herveo',
  },
  {
    nombre: 'Hispania',
    codigo: '5.353',
    departamento: 'Antioquia',
    normalizada: 'hispania',
  },
  {
    nombre: 'Hobo',
    codigo: '41.349',
    departamento: 'Huila',
    normalizada: 'hobo',
  },
  {
    nombre: 'Honda',
    codigo: '73.349',
    departamento: 'Tolima',
    normalizada: 'honda',
  },
  {
    nombre: 'Ibagué',
    codigo: '73.001',
    departamento: 'Tolima',
    normalizada: 'ibague',
  },
  {
    nombre: 'Icononzo',
    codigo: '73.352',
    departamento: 'Tolima',
    normalizada: 'icononzo',
  },
  {
    nombre: 'Iles',
    codigo: '52.352',
    departamento: 'Nariño',
    normalizada: 'iles',
  },
  {
    nombre: 'Imués',
    codigo: '52.354',
    departamento: 'Nariño',
    normalizada: 'imues',
  },
  {
    nombre: 'Inírida',
    codigo: '94.001',
    departamento: 'Guainía',
    normalizada: 'inirida',
  },
  {
    nombre: 'Inzá',
    codigo: '19.355',
    departamento: 'Cauca',
    normalizada: 'inza',
  },
  {
    nombre: 'Ipiales',
    codigo: '52.356',
    departamento: 'Nariño',
    normalizada: 'ipiales',
  },
  {
    nombre: 'Íquira',
    codigo: '41.357',
    departamento: 'Huila',
    normalizada: 'iquira',
  },
  {
    nombre: 'Isnos',
    codigo: '41.359',
    departamento: 'Huila',
    normalizada: 'isnos',
  },
  {
    nombre: 'Istmina',
    codigo: '27.361',
    departamento: 'Chocó',
    normalizada: 'istmina',
  },
  {
    nombre: 'Itagüí',
    codigo: '5.36',
    departamento: 'Antioquia',
    normalizada: 'itagui',
  },
  {
    nombre: 'Ituango',
    codigo: '5.361',
    departamento: 'Antioquia',
    normalizada: 'ituango',
  },
  {
    nombre: 'Iza',
    codigo: '15.362',
    departamento: 'Boyacá',
    normalizada: 'iza',
  },
  {
    nombre: 'Jambaló',
    codigo: '19.364',
    departamento: 'Cauca',
    normalizada: 'jambalo',
  },
  {
    nombre: 'Jamundí',
    codigo: '76.364',
    departamento: 'Valle del Cauca',
    normalizada: 'jamundi',
  },
  {
    nombre: 'Jardín',
    codigo: '5.364',
    departamento: 'Antioquia',
    normalizada: 'jardin',
  },
  {
    nombre: 'Jenesano',
    codigo: '15.367',
    departamento: 'Boyacá',
    normalizada: 'jenesano',
  },
  {
    nombre: 'Jericó',
    codigo: '5.368',
    departamento: 'Antioquia',
    normalizada: 'jerico',
  },
  {
    nombre: 'Jericó',
    codigo: '15.368',
    departamento: 'Boyacá',
    normalizada: 'jerico',
  },
  {
    nombre: 'Jerusalén',
    codigo: '25.368',
    departamento: 'Cundinamarca',
    normalizada: 'jerusalen',
  },
  {
    nombre: 'Jesús María',
    codigo: '68.368',
    departamento: 'Santander',
    normalizada: 'jesusmaria',
  },
  {
    nombre: 'Jordán',
    codigo: '68.37',
    departamento: 'Santander',
    normalizada: 'jordan',
  },
  {
    nombre: 'Juan de Acosta',
    codigo: '8.372',
    departamento: 'Atlántico',
    normalizada: 'juandeacosta',
  },
  {
    nombre: 'Junín',
    codigo: '25.372',
    departamento: 'Cundinamarca',
    normalizada: 'junin',
  },
  {
    nombre: 'Juradó',
    codigo: '27.372',
    departamento: 'Chocó',
    normalizada: 'jurado',
  },
  {
    nombre: 'La Apartada',
    codigo: '23.35',
    departamento: 'Córdoba',
    normalizada: 'laapartada',
  },
  {
    nombre: 'La Argentina',
    codigo: '41.378',
    departamento: 'Huila',
    normalizada: 'laargentina',
  },
  {
    nombre: 'La Belleza',
    codigo: '68.377',
    departamento: 'Santander',
    normalizada: 'labelleza',
  },
  {
    nombre: 'La Calera',
    codigo: '25.377',
    departamento: 'Cundinamarca',
    normalizada: 'lacalera',
  },
  {
    nombre: 'La Capilla',
    codigo: '15.38',
    departamento: 'Boyacá',
    normalizada: 'lacapilla',
  },
  {
    nombre: 'La Ceja',
    codigo: '5.376',
    departamento: 'Antioquia',
    normalizada: 'laceja',
  },
  {
    nombre: 'La Celia',
    codigo: '66.383',
    departamento: 'Risaralda',
    normalizada: 'lacelia',
  },
  {
    nombre: 'La Chorrera',
    codigo: '91.405',
    departamento: 'Amazonas',
    normalizada: 'lachorrera',
  },
  {
    nombre: 'La Cruz',
    codigo: '52.378',
    departamento: 'Nariño',
    normalizada: 'lacruz',
  },
  {
    nombre: 'La Cumbre',
    codigo: '76.377',
    departamento: 'Valle del Cauca',
    normalizada: 'lacumbre',
  },
  {
    nombre: 'La Dorada',
    codigo: '17.38',
    departamento: 'Caldas',
    normalizada: 'ladorada',
  },
  {
    nombre: 'La Esperanza',
    codigo: '54.385',
    departamento: 'Norte de Santander',
    normalizada: 'laesperanza',
  },
  {
    nombre: 'La Estrella',
    codigo: '5.38',
    departamento: 'Antioquia',
    normalizada: 'laestrella',
  },
  {
    nombre: 'La Florida',
    codigo: '52.381',
    departamento: 'Nariño',
    normalizada: 'laflorida',
  },
  {
    nombre: 'La Gloria',
    codigo: '20.383',
    departamento: 'Cesár',
    normalizada: 'lagloria',
  },
  {
    nombre: 'La Guadalupe',
    codigo: '94.885',
    departamento: 'Guainía',
    normalizada: 'laguadalupe',
  },
  {
    nombre: 'La Jagua de Ibirico',
    codigo: '20.4',
    departamento: 'Cesár',
    normalizada: 'lajaguadeibirico',
  },
  {
    nombre: 'La Jagua del Pilar',
    codigo: '44.42',
    departamento: 'La Guajira',
    normalizada: 'lajaguadelpilar',
  },
  {
    nombre: 'La Llanada',
    codigo: '52.385',
    departamento: 'Nariño',
    normalizada: 'lallanada',
  },
  {
    nombre: 'La Macarena',
    codigo: '50.35',
    departamento: 'Meta',
    normalizada: 'lamacarena',
  },
  {
    nombre: 'La Merced',
    codigo: '17.388',
    departamento: 'Caldas',
    normalizada: 'lamerced',
  },
  {
    nombre: 'La Mesa',
    codigo: '25.386',
    departamento: 'Cundinamarca',
    normalizada: 'lamesa',
  },
  {
    nombre: 'La Montañita',
    codigo: '18.41',
    departamento: 'Caquetá',
    normalizada: 'lamontanita',
  },
  {
    nombre: 'La Palma',
    codigo: '25.394',
    departamento: 'Cundinamarca',
    normalizada: 'lapalma',
  },
  {
    nombre: 'La Paz',
    codigo: '20.621',
    departamento: 'Cesár',
    normalizada: 'lapaz',
  },
  {
    nombre: 'La Paz',
    codigo: '68.397',
    departamento: 'Santander',
    normalizada: 'lapaz',
  },
  {
    nombre: 'La Pedrera',
    codigo: '91.407',
    departamento: 'Amazonas',
    normalizada: 'lapedrera',
  },
  {
    nombre: 'La Peña',
    codigo: '25.398',
    departamento: 'Cundinamarca',
    normalizada: 'lapena',
  },
  {
    nombre: 'La Pintada',
    codigo: '5.39',
    departamento: 'Antioquia',
    normalizada: 'lapintada',
  },
  {
    nombre: 'La Plata',
    codigo: '41.396',
    departamento: 'Huila',
    normalizada: 'laplata',
  },
  {
    nombre: 'La Playa',
    codigo: '54.398',
    departamento: 'Norte de Santander',
    normalizada: 'laplaya',
  },
  {
    nombre: 'La Primavera',
    codigo: '99.524',
    departamento: 'Vichada',
    normalizada: 'laprimavera',
  },
  {
    nombre: 'La Salina',
    codigo: '85.136',
    departamento: 'Casanare',
    normalizada: 'lasalina',
  },
  {
    nombre: 'La Sierra',
    codigo: '19.392',
    departamento: 'Cauca',
    normalizada: 'lasierra',
  },
  {
    nombre: 'La Tebaida',
    codigo: '63.401',
    departamento: 'Quindío',
    normalizada: 'latebaida',
  },
  {
    nombre: 'La Tola',
    codigo: '52.39',
    departamento: 'Nariño',
    normalizada: 'latola',
  },
  {
    nombre: 'La Unión',
    codigo: '5.4',
    departamento: 'Antioquia',
    normalizada: 'launion',
  },
  {
    nombre: 'La Unión',
    codigo: '52.399',
    departamento: 'Nariño',
    normalizada: 'launion',
  },
  {
    nombre: 'La Unión',
    codigo: '70.4',
    departamento: 'Sucre',
    normalizada: 'launion',
  },
  {
    nombre: 'La Unión',
    codigo: '76.4',
    departamento: 'Valle del Cauca',
    normalizada: 'launion',
  },
  {
    nombre: 'La Uvita',
    codigo: '15.403',
    departamento: 'Boyacá',
    normalizada: 'lauvita',
  },
  {
    nombre: 'La Vega',
    codigo: '19.397',
    departamento: 'Cauca',
    normalizada: 'lavega',
  },
  {
    nombre: 'La Vega',
    codigo: '25.402',
    departamento: 'Cundinamarca',
    normalizada: 'lavega',
  },
  {
    nombre: 'La Victoria',
    codigo: '15.401',
    departamento: 'Boyacá',
    normalizada: 'lavictoria',
  },
  {
    nombre: 'La Victoria',
    codigo: '91.43',
    departamento: 'Amazonas',
    normalizada: 'lavictoria',
  },
  {
    nombre: 'La Victoria',
    codigo: '76.403',
    departamento: 'Valle del Cauca',
    normalizada: 'lavictoria',
  },
  {
    nombre: 'La Virginia',
    codigo: '66.4',
    departamento: 'Risaralda',
    normalizada: 'lavirginia',
  },
  {
    nombre: 'Labateca',
    codigo: '54.377',
    departamento: 'Norte de Santander',
    normalizada: 'labateca',
  },
  {
    nombre: 'Labranzagrande',
    codigo: '15.377',
    departamento: 'Boyacá',
    normalizada: 'labranzagrande',
  },
  {
    nombre: 'Landázuri',
    codigo: '68.385',
    departamento: 'Santander',
    normalizada: 'landazuri',
  },
  {
    nombre: 'Lebríja',
    codigo: '68.406',
    departamento: 'Santander',
    normalizada: 'lebrija',
  },
  {
    nombre: 'Leiva',
    codigo: '52.405',
    departamento: 'Nariño',
    normalizada: 'leiva',
  },
  {
    nombre: 'Lejanías',
    codigo: '50.4',
    departamento: 'Meta',
    normalizada: 'lejanias',
  },
  {
    nombre: 'Lenguazaque',
    codigo: '25.407',
    departamento: 'Cundinamarca',
    normalizada: 'lenguazaque',
  },
  {
    nombre: 'Lérida',
    codigo: '73.408',
    departamento: 'Tolima',
    normalizada: 'lerida',
  },
  {
    nombre: 'Leticia',
    codigo: '91.001',
    departamento: 'Amazonas',
    normalizada: 'leticia',
  },
  {
    nombre: 'Líbano',
    codigo: '73.411',
    departamento: 'Tolima',
    normalizada: 'libano',
  },
  {
    nombre: 'Liborina',
    codigo: '5.411',
    departamento: 'Antioquia',
    normalizada: 'liborina',
  },
  {
    nombre: 'Linares',
    codigo: '52.411',
    departamento: 'Nariño',
    normalizada: 'linares',
  },
  {
    nombre: 'Lloró',
    codigo: '27.413',
    departamento: 'Chocó',
    normalizada: 'lloro',
  },
  {
    nombre: 'López de Micay',
    codigo: '19.418',
    departamento: 'Cauca',
    normalizada: 'lopezdemicay',
  },
  {
    nombre: 'Lorica',
    codigo: '23.417',
    departamento: 'Córdoba',
    normalizada: 'lorica',
  },
  {
    nombre: 'Los Andes',
    codigo: '52.418',
    departamento: 'Nariño',
    normalizada: 'losandes',
  },
  {
    nombre: 'Los Córdobas',
    codigo: '23.419',
    departamento: 'Córdoba',
    normalizada: 'loscordobas',
  },
  {
    nombre: 'Los Palmitos',
    codigo: '70.418',
    departamento: 'Sucre',
    normalizada: 'lospalmitos',
  },
  {
    nombre: 'Los Patios',
    codigo: '54.405',
    departamento: 'Norte de Santander',
    normalizada: 'lospatios',
  },
  {
    nombre: 'Los Santos',
    codigo: '68.418',
    departamento: 'Santander',
    normalizada: 'lossantos',
  },
  {
    nombre: 'Lourdes',
    codigo: '54.418',
    departamento: 'Norte de Santander',
    normalizada: 'lourdes',
  },
  {
    nombre: 'Luruaco',
    codigo: '8.421',
    departamento: 'Atlántico',
    normalizada: 'luruaco',
  },
  {
    nombre: 'Macanal',
    codigo: '15.425',
    departamento: 'Boyacá',
    normalizada: 'macanal',
  },
  {
    nombre: 'Macaravita',
    codigo: '68.425',
    departamento: 'Santander',
    normalizada: 'macaravita',
  },
  {
    nombre: 'Maceo',
    codigo: '5.425',
    departamento: 'Antioquia',
    normalizada: 'maceo',
  },
  {
    nombre: 'Machetá',
    codigo: '25.426',
    departamento: 'Cundinamarca',
    normalizada: 'macheta',
  },
  {
    nombre: 'Madrid',
    codigo: '25.43',
    departamento: 'Cundinamarca',
    normalizada: 'madrid',
  },
  {
    nombre: 'Magangué',
    codigo: '13.43',
    departamento: 'Bolívar',
    normalizada: 'magangue',
  },
  {
    nombre: 'Magüí',
    codigo: '52.427',
    departamento: 'Nariño',
    normalizada: 'magui',
  },
  {
    nombre: 'Mahates',
    codigo: '13.433',
    departamento: 'Bolívar',
    normalizada: 'mahates',
  },
  {
    nombre: 'Maicao',
    codigo: '44.43',
    departamento: 'La Guajira',
    normalizada: 'maicao',
  },
  {
    nombre: 'Majagual',
    codigo: '70.429',
    departamento: 'Sucre',
    normalizada: 'majagual',
  },
  {
    nombre: 'Málaga',
    codigo: '68.432',
    departamento: 'Santander',
    normalizada: 'malaga',
  },
  {
    nombre: 'Malambo',
    codigo: '8.433',
    departamento: 'Atlántico',
    normalizada: 'malambo',
  },
  {
    nombre: 'Mallama',
    codigo: '52.435',
    departamento: 'Nariño',
    normalizada: 'mallama',
  },
  {
    nombre: 'Manatí',
    codigo: '8.436',
    departamento: 'Atlántico',
    normalizada: 'manati',
  },
  {
    nombre: 'Manaure',
    codigo: '44.56',
    departamento: 'La Guajira',
    normalizada: 'manaure',
  },
  {
    nombre: 'Manaure Balcón del Cesár',
    codigo: '20.443',
    departamento: 'Cesár',
    normalizada: 'manaurebalcondelcesar',
  },
  {
    nombre: 'Maní',
    codigo: '85.139',
    departamento: 'Casanare',
    normalizada: 'mani',
  },
  {
    nombre: 'Manizales',
    codigo: '17.001',
    departamento: 'Caldas',
    normalizada: 'manizales',
  },
  {
    nombre: 'Manta',
    codigo: '25.436',
    departamento: 'Cundinamarca',
    normalizada: 'manta',
  },
  {
    nombre: 'Manzanares',
    codigo: '17.433',
    departamento: 'Caldas',
    normalizada: 'manzanares',
  },
  {
    nombre: 'Mapiripán',
    codigo: '50.325',
    departamento: 'Meta',
    normalizada: 'mapiripan',
  },
  {
    nombre: 'Mapiripana',
    codigo: '94.663',
    departamento: 'Guainía',
    normalizada: 'mapiripana',
  },
  {
    nombre: 'Margarita',
    codigo: '13.44',
    departamento: 'Bolívar',
    normalizada: 'margarita',
  },
  {
    nombre: 'María La Baja',
    codigo: '13.442',
    departamento: 'Bolívar',
    normalizada: 'marialabaja',
  },
  {
    nombre: 'Marinilla',
    codigo: '5.44',
    departamento: 'Antioquia',
    normalizada: 'marinilla',
  },
  {
    nombre: 'Maripí',
    codigo: '15.442',
    departamento: 'Boyacá',
    normalizada: 'maripi',
  },
  {
    nombre: 'Mariquita',
    codigo: '73.443',
    departamento: 'Tolima',
    normalizada: 'mariquita',
  },
  {
    nombre: 'Marmato',
    codigo: '17.442',
    departamento: 'Caldas',
    normalizada: 'marmato',
  },
  {
    nombre: 'Marquetalia',
    codigo: '17.444',
    departamento: 'Caldas',
    normalizada: 'marquetalia',
  },
  {
    nombre: 'Marsella',
    codigo: '66.44',
    departamento: 'Risaralda',
    normalizada: 'marsella',
  },
  {
    nombre: 'Marulanda',
    codigo: '17.446',
    departamento: 'Caldas',
    normalizada: 'marulanda',
  },
  {
    nombre: 'Matanza',
    codigo: '68.444',
    departamento: 'Santander',
    normalizada: 'matanza',
  },
  {
    nombre: 'Medellín',
    codigo: '5.001',
    departamento: 'Antioquia',
    normalizada: 'medellin',
  },
  {
    nombre: 'Medina',
    codigo: '25.438',
    departamento: 'Cundinamarca',
    normalizada: 'medina',
  },
  {
    nombre: 'Medio Atrato',
    codigo: '27.425',
    departamento: 'Chocó',
    normalizada: 'medioatrato',
  },
  {
    nombre: 'Medio Baudó',
    codigo: '27.43',
    departamento: 'Chocó',
    normalizada: 'mediobaudo',
  },
  {
    nombre: 'Medio San Juan',
    codigo: '27.45',
    departamento: 'Chocó',
    normalizada: 'mediosanjuan',
  },
  {
    nombre: 'Melgar',
    codigo: '73.449',
    departamento: 'Tolima',
    normalizada: 'melgar',
  },
  {
    nombre: 'Mercaderes',
    codigo: '19.45',
    departamento: 'Cauca',
    normalizada: 'mercaderes',
  },
  {
    nombre: 'Mesetas',
    codigo: '50.33',
    departamento: 'Meta',
    normalizada: 'mesetas',
  },
  {
    nombre: 'Milán',
    codigo: '18.46',
    departamento: 'Caquetá',
    normalizada: 'milan',
  },
  {
    nombre: 'Miraflores',
    codigo: '15.455',
    departamento: 'Boyacá',
    normalizada: 'miraflores',
  },
  {
    nombre: 'Miraflores',
    codigo: '95.2',
    departamento: 'Guaviare',
    normalizada: 'miraflores',
  },
  {
    nombre: 'Miranda',
    codigo: '19.455',
    departamento: 'Cauca',
    normalizada: 'miranda',
  },
  {
    nombre: 'Mirití Paraná',
    codigo: '91.46',
    departamento: 'Amazonas',
    normalizada: 'miritiparana',
  },
  {
    nombre: 'Mistrató',
    codigo: '66.456',
    departamento: 'Risaralda',
    normalizada: 'mistrato',
  },
  {
    nombre: 'Mitú',
    codigo: '97.001',
    departamento: 'Vaupés',
    normalizada: 'mitu',
  },
  {
    nombre: 'Mocoa',
    codigo: '86.001',
    departamento: 'Putumayo',
    normalizada: 'mocoa',
  },
  {
    nombre: 'Mogotes',
    codigo: '68.464',
    departamento: 'Santander',
    normalizada: 'mogotes',
  },
  {
    nombre: 'Molagavita',
    codigo: '68.468',
    departamento: 'Santander',
    normalizada: 'molagavita',
  },
  {
    nombre: 'Momil',
    codigo: '23.464',
    departamento: 'Córdoba',
    normalizada: 'momil',
  },
  {
    nombre: 'Mongua',
    codigo: '15.464',
    departamento: 'Boyacá',
    normalizada: 'mongua',
  },
  {
    nombre: 'Monguí',
    codigo: '15.466',
    departamento: 'Boyacá',
    normalizada: 'mongui',
  },
  {
    nombre: 'Moniquirá',
    codigo: '15.469',
    departamento: 'Boyacá',
    normalizada: 'moniquira',
  },
  {
    nombre: 'Montebello',
    codigo: '5.467',
    departamento: 'Antioquia',
    normalizada: 'montebello',
  },
  {
    nombre: 'Montecristo',
    codigo: '13.458',
    departamento: 'Bolívar',
    normalizada: 'montecristo',
  },
  {
    nombre: 'Montelíbano',
    codigo: '23.466',
    departamento: 'Córdoba',
    normalizada: 'montelibano',
  },
  {
    nombre: 'Montenegro',
    codigo: '63.47',
    departamento: 'Quindío',
    normalizada: 'montenegro',
  },
  {
    nombre: 'Montería',
    codigo: '23.001',
    departamento: 'Córdoba',
    normalizada: 'monteria',
  },
  {
    nombre: 'Monterrey',
    codigo: '85.162',
    departamento: 'Casanare',
    normalizada: 'monterrey',
  },
  {
    nombre: 'Moñitos',
    codigo: '23.5',
    departamento: 'Córdoba',
    normalizada: 'monitos',
  },
  {
    nombre: 'Morales',
    codigo: '13.473',
    departamento: 'Bolívar',
    normalizada: 'morales',
  },
  {
    nombre: 'Morales',
    codigo: '19.473',
    departamento: 'Cauca',
    normalizada: 'morales',
  },
  {
    nombre: 'Morelia',
    codigo: '18.479',
    departamento: 'Caquetá',
    normalizada: 'morelia',
  },
  {
    nombre: 'Morichal',
    codigo: '94.888',
    departamento: 'Guainía',
    normalizada: 'morichal',
  },
  {
    nombre: 'Morroa',
    codigo: '70.473',
    departamento: 'Sucre',
    normalizada: 'morroa',
  },
  {
    nombre: 'Mosquera',
    codigo: '25.473',
    departamento: 'Cundinamarca',
    normalizada: 'mosquera',
  },
  {
    nombre: 'Mosquera',
    codigo: '52.473',
    departamento: 'Nariño',
    normalizada: 'mosquera',
  },
  {
    nombre: 'Motavita',
    codigo: '15.476',
    departamento: 'Boyacá',
    normalizada: 'motavita',
  },
  {
    nombre: 'Murillo',
    codigo: '73.461',
    departamento: 'Tolima',
    normalizada: 'murillo',
  },
  {
    nombre: 'Murindó',
    codigo: '5.475',
    departamento: 'Antioquia',
    normalizada: 'murindo',
  },
  {
    nombre: 'Mutatá',
    codigo: '5.48',
    departamento: 'Antioquia',
    normalizada: 'mutata',
  },
  {
    nombre: 'Mutiscua',
    codigo: '54.48',
    departamento: 'Norte de Santander',
    normalizada: 'mutiscua',
  },
  {
    nombre: 'Muzo',
    codigo: '15.48',
    departamento: 'Boyacá',
    normalizada: 'muzo',
  },
  {
    nombre: 'Nariño',
    codigo: '5.483',
    departamento: 'Antioquia',
    normalizada: 'narino',
  },
  {
    nombre: 'Nariño',
    codigo: '25.483',
    departamento: 'Cundinamarca',
    normalizada: 'narino',
  },
  {
    nombre: 'Nariño',
    codigo: '52.48',
    departamento: 'Nariño',
    normalizada: 'narino',
  },
  {
    nombre: 'Nátaga',
    codigo: '41.483',
    departamento: 'Huila',
    normalizada: 'nataga',
  },
  {
    nombre: 'Natagaima',
    codigo: '73.483',
    departamento: 'Tolima',
    normalizada: 'natagaima',
  },
  {
    nombre: 'Nechí',
    codigo: '5.495',
    departamento: 'Antioquia',
    normalizada: 'nechi',
  },
  {
    nombre: 'Necoclí',
    codigo: '5.49',
    departamento: 'Antioquia',
    normalizada: 'necocli',
  },
  {
    nombre: 'Neira',
    codigo: '17.486',
    departamento: 'Caldas',
    normalizada: 'neira',
  },
  {
    nombre: 'Neiva',
    codigo: '41.001',
    departamento: 'Huila',
    normalizada: 'neiva',
  },
  {
    nombre: 'Nemocón',
    codigo: '25.486',
    departamento: 'Cundinamarca',
    normalizada: 'nemocon',
  },
  {
    nombre: 'Nilo',
    codigo: '25.488',
    departamento: 'Cundinamarca',
    normalizada: 'nilo',
  },
  {
    nombre: 'Nimaima',
    codigo: '25.489',
    departamento: 'Cundinamarca',
    normalizada: 'nimaima',
  },
  {
    nombre: 'Nobsa',
    codigo: '15.491',
    departamento: 'Boyacá',
    normalizada: 'nobsa',
  },
  {
    nombre: 'Nocaima',
    codigo: '25.491',
    departamento: 'Cundinamarca',
    normalizada: 'nocaima',
  },
  {
    nombre: 'Norcasia',
    codigo: '17.495',
    departamento: 'Caldas',
    normalizada: 'norcasia',
  },
  {
    nombre: 'Norosí',
    codigo: '13.49',
    departamento: 'Bolívar',
    normalizada: 'norosi',
  },
  {
    nombre: 'Nóvita',
    codigo: '27.491',
    departamento: 'Chocó',
    normalizada: 'novita',
  },
  {
    nombre: 'Nueva Granada',
    codigo: '47.46',
    departamento: 'Magdalena',
    normalizada: 'nuevagranada',
  },
  {
    nombre: 'Nuevo Belén de Bajirá',
    codigo: '27.086',
    departamento: 'Chocó',
    normalizada: 'nuevobelendebajira',
  },
  {
    nombre: 'Nuevo Colón',
    codigo: '15.494',
    departamento: 'Boyacá',
    normalizada: 'nuevocolon',
  },
  {
    nombre: 'Nunchía',
    codigo: '85.225',
    departamento: 'Casanare',
    normalizada: 'nunchia',
  },
  {
    nombre: 'Nuquí',
    codigo: '27.495',
    departamento: 'Chocó',
    normalizada: 'nuqui',
  },
  {
    nombre: 'Obando',
    codigo: '76.497',
    departamento: 'Valle del Cauca',
    normalizada: 'obando',
  },
  {
    nombre: 'Ocamonte',
    codigo: '68.498',
    departamento: 'Santander',
    normalizada: 'ocamonte',
  },
  {
    nombre: 'Ocaña',
    codigo: '54.498',
    departamento: 'Norte de Santander',
    normalizada: 'ocana',
  },
  {
    nombre: 'Oiba',
    codigo: '68.5',
    departamento: 'Santander',
    normalizada: 'oiba',
  },
  {
    nombre: 'Oicatá',
    codigo: '15.5',
    departamento: 'Boyacá',
    normalizada: 'oicata',
  },
  {
    nombre: 'Olaya',
    codigo: '5.501',
    departamento: 'Antioquia',
    normalizada: 'olaya',
  },
  {
    nombre: 'Olaya Herrera',
    codigo: '52.49',
    departamento: 'Nariño',
    normalizada: 'olayaherrera',
  },
  {
    nombre: 'Onzaga',
    codigo: '68.502',
    departamento: 'Santander',
    normalizada: 'onzaga',
  },
  {
    nombre: 'Oporapa',
    codigo: '41.503',
    departamento: 'Huila',
    normalizada: 'oporapa',
  },
  {
    nombre: 'Orito',
    codigo: '86.32',
    departamento: 'Putumayo',
    normalizada: 'orito',
  },
  {
    nombre: 'Orocué',
    codigo: '85.23',
    departamento: 'Casanare',
    normalizada: 'orocue',
  },
  {
    nombre: 'Ortega',
    codigo: '73.504',
    departamento: 'Tolima',
    normalizada: 'ortega',
  },
  {
    nombre: 'Ospina',
    codigo: '52.506',
    departamento: 'Nariño',
    normalizada: 'ospina',
  },
  {
    nombre: 'Otanche',
    codigo: '15.507',
    departamento: 'Boyacá',
    normalizada: 'otanche',
  },
  {
    nombre: 'Ovejas',
    codigo: '70.508',
    departamento: 'Sucre',
    normalizada: 'ovejas',
  },
  {
    nombre: 'Pachavita',
    codigo: '15.511',
    departamento: 'Boyacá',
    normalizada: 'pachavita',
  },
  {
    nombre: 'Pacho',
    codigo: '25.513',
    departamento: 'Cundinamarca',
    normalizada: 'pacho',
  },
  {
    nombre: 'Pacoa',
    codigo: '97.511',
    departamento: 'Vaupés',
    normalizada: 'pacoa',
  },
  {
    nombre: 'Pácora',
    codigo: '17.513',
    departamento: 'Caldas',
    normalizada: 'pacora',
  },
  {
    nombre: 'Padilla',
    codigo: '19.513',
    departamento: 'Cauca',
    normalizada: 'padilla',
  },
  {
    nombre: 'Páez',
    codigo: '15.514',
    departamento: 'Boyacá',
    normalizada: 'paez',
  },
  {
    nombre: 'Páez',
    codigo: '19.517',
    departamento: 'Cauca',
    normalizada: 'paez',
  },
  {
    nombre: 'Paicol',
    codigo: '41.518',
    departamento: 'Huila',
    normalizada: 'paicol',
  },
  {
    nombre: 'Pailitas',
    codigo: '20.517',
    departamento: 'Cesár',
    normalizada: 'pailitas',
  },
  {
    nombre: 'Paime',
    codigo: '25.518',
    departamento: 'Cundinamarca',
    normalizada: 'paime',
  },
  {
    nombre: 'Paipa',
    codigo: '15.516',
    departamento: 'Boyacá',
    normalizada: 'paipa',
  },
  {
    nombre: 'Pajarito',
    codigo: '15.518',
    departamento: 'Boyacá',
    normalizada: 'pajarito',
  },
  {
    nombre: 'Palermo',
    codigo: '41.524',
    departamento: 'Huila',
    normalizada: 'palermo',
  },
  {
    nombre: 'Palestina',
    codigo: '17.524',
    departamento: 'Caldas',
    normalizada: 'palestina',
  },
  {
    nombre: 'Palestina',
    codigo: '41.53',
    departamento: 'Huila',
    normalizada: 'palestina',
  },
  {
    nombre: 'Palmar',
    codigo: '68.522',
    departamento: 'Santander',
    normalizada: 'palmar',
  },
  {
    nombre: 'Palmar de Varela',
    codigo: '8.52',
    departamento: 'Atlántico',
    normalizada: 'palmardevarela',
  },
  {
    nombre: 'Palmas del Socorro',
    codigo: '68.524',
    departamento: 'Santander',
    normalizada: 'palmasdelsocorro',
  },
  {
    nombre: 'Palmira',
    codigo: '76.52',
    departamento: 'Valle del Cauca',
    normalizada: 'palmira',
  },
  {
    nombre: 'Palmito',
    codigo: '70.523',
    departamento: 'Sucre',
    normalizada: 'palmito',
  },
  {
    nombre: 'Palocabildo',
    codigo: '73.52',
    departamento: 'Tolima',
    normalizada: 'palocabildo',
  },
  {
    nombre: 'Pamplona',
    codigo: '54.518',
    departamento: 'Norte de Santander',
    normalizada: 'pamplona',
  },
  {
    nombre: 'Pamplonita',
    codigo: '54.52',
    departamento: 'Norte de Santander',
    normalizada: 'pamplonita',
  },
  {
    nombre: 'Pana Pana',
    codigo: '94.887',
    departamento: 'Guainía',
    normalizada: 'panapana',
  },
  {
    nombre: 'Pandi',
    codigo: '25.524',
    departamento: 'Cundinamarca',
    normalizada: 'pandi',
  },
  {
    nombre: 'Panqueba',
    codigo: '15.522',
    departamento: 'Boyacá',
    normalizada: 'panqueba',
  },
  {
    nombre: 'Papunahua',
    codigo: '97.777',
    departamento: 'Vaupés',
    normalizada: 'papunahua',
  },
  {
    nombre: 'Páramo',
    codigo: '68.533',
    departamento: 'Santander',
    normalizada: 'paramo',
  },
  {
    nombre: 'Paratebueno',
    codigo: '25.53',
    departamento: 'Cundinamarca',
    normalizada: 'paratebueno',
  },
  {
    nombre: 'Pasca',
    codigo: '25.535',
    departamento: 'Cundinamarca',
    normalizada: 'pasca',
  },
  {
    nombre: 'Pasto',
    codigo: '52.001',
    departamento: 'Nariño',
    normalizada: 'pasto',
  },
  {
    nombre: 'Patía',
    codigo: '19.532',
    departamento: 'Cauca',
    normalizada: 'patia',
  },
  {
    nombre: 'Pauna',
    codigo: '15.531',
    departamento: 'Boyacá',
    normalizada: 'pauna',
  },
  {
    nombre: 'Paya',
    codigo: '15.533',
    departamento: 'Boyacá',
    normalizada: 'paya',
  },
  {
    nombre: 'Paz de Ariporo',
    codigo: '85.25',
    departamento: 'Casanare',
    normalizada: 'pazdeariporo',
  },
  {
    nombre: 'Paz de Río',
    codigo: '15.537',
    departamento: 'Boyacá',
    normalizada: 'pazderio',
  },
  {
    nombre: 'Pedraza',
    codigo: '47.541',
    departamento: 'Magdalena',
    normalizada: 'pedraza',
  },
  {
    nombre: 'Pelaya',
    codigo: '20.55',
    departamento: 'Cesár',
    normalizada: 'pelaya',
  },
  {
    nombre: 'Pensilvania',
    codigo: '17.541',
    departamento: 'Caldas',
    normalizada: 'pensilvania',
  },
  {
    nombre: 'Peñol',
    codigo: '5.541',
    departamento: 'Antioquia',
    normalizada: 'penol',
  },
  {
    nombre: 'Peque',
    codigo: '5.543',
    departamento: 'Antioquia',
    normalizada: 'peque',
  },
  {
    nombre: 'Pereira',
    codigo: '66.001',
    departamento: 'Risaralda',
    normalizada: 'pereira',
  },
  {
    nombre: 'Pesca',
    codigo: '15.542',
    departamento: 'Boyacá',
    normalizada: 'pesca',
  },
  {
    nombre: 'Piamonte',
    codigo: '19.533',
    departamento: 'Cauca',
    normalizada: 'piamonte',
  },
  {
    nombre: 'Piedecuesta',
    codigo: '68.547',
    departamento: 'Santander',
    normalizada: 'piedecuesta',
  },
  {
    nombre: 'Piedras',
    codigo: '73.547',
    departamento: 'Tolima',
    normalizada: 'piedras',
  },
  {
    nombre: 'Piendamó',
    codigo: '19.548',
    departamento: 'Cauca',
    normalizada: 'piendamo',
  },
  {
    nombre: 'Pijao',
    codigo: '63.548',
    departamento: 'Quindío',
    normalizada: 'pijao',
  },
  {
    nombre: 'Pijiño del Carmen',
    codigo: '47.545',
    departamento: 'Magdalena',
    normalizada: 'pijinodelcarmen',
  },
  {
    nombre: 'Pinchote',
    codigo: '68.549',
    departamento: 'Santander',
    normalizada: 'pinchote',
  },
  {
    nombre: 'Pinillos',
    codigo: '13.549',
    departamento: 'Bolívar',
    normalizada: 'pinillos',
  },
  {
    nombre: 'Piojó',
    codigo: '8.549',
    departamento: 'Atlántico',
    normalizada: 'piojo',
  },
  {
    nombre: 'Pisba',
    codigo: '15.55',
    departamento: 'Boyacá',
    normalizada: 'pisba',
  },
  {
    nombre: 'Pital',
    codigo: '41.548',
    departamento: 'Huila',
    normalizada: 'pital',
  },
  {
    nombre: 'Pitalito',
    codigo: '41.551',
    departamento: 'Huila',
    normalizada: 'pitalito',
  },
  {
    nombre: 'Pivijay',
    codigo: '47.551',
    departamento: 'Magdalena',
    normalizada: 'pivijay',
  },
  {
    nombre: 'Planadas',
    codigo: '73.555',
    departamento: 'Tolima',
    normalizada: 'planadas',
  },
  {
    nombre: 'Planeta Rica',
    codigo: '23.555',
    departamento: 'Córdoba',
    normalizada: 'planetarica',
  },
  {
    nombre: 'Plato',
    codigo: '47.555',
    departamento: 'Magdalena',
    normalizada: 'plato',
  },
  {
    nombre: 'Policarpa',
    codigo: '52.54',
    departamento: 'Nariño',
    normalizada: 'policarpa',
  },
  {
    nombre: 'Polonuevo',
    codigo: '8.558',
    departamento: 'Atlántico',
    normalizada: 'polonuevo',
  },
  {
    nombre: 'Ponedera',
    codigo: '8.56',
    departamento: 'Atlántico',
    normalizada: 'ponedera',
  },
  {
    nombre: 'Popayán',
    codigo: '19.001',
    departamento: 'Cauca',
    normalizada: 'popayan',
  },
  {
    nombre: 'Pore',
    codigo: '85.263',
    departamento: 'Casanare',
    normalizada: 'pore',
  },
  {
    nombre: 'Potosí',
    codigo: '52.56',
    departamento: 'Nariño',
    normalizada: 'potosi',
  },
  {
    nombre: 'Pradera',
    codigo: '76.563',
    departamento: 'Valle del Cauca',
    normalizada: 'pradera',
  },
  {
    nombre: 'Prado',
    codigo: '73.563',
    departamento: 'Tolima',
    normalizada: 'prado',
  },
  {
    nombre: 'Providencia',
    codigo: '52.565',
    departamento: 'Nariño',
    normalizada: 'providencia',
  },
  {
    nombre: 'Providencia',
    codigo: '88.564',
    departamento: 'Archipiélago de San Andrés, Providencia y Santa Catalina',
    normalizada: 'providencia',
  },
  {
    nombre: 'Pueblo Bello',
    codigo: '20.57',
    departamento: 'Cesár',
    normalizada: 'pueblobello',
  },
  {
    nombre: 'Pueblo Nuevo',
    codigo: '23.57',
    departamento: 'Córdoba',
    normalizada: 'pueblonuevo',
  },
  {
    nombre: 'Pueblo Rico',
    codigo: '66.572',
    departamento: 'Risaralda',
    normalizada: 'pueblorico',
  },
  {
    nombre: 'Pueblo Viejo',
    codigo: '47.57',
    departamento: 'Magdalena',
    normalizada: 'puebloviejo',
  },
  {
    nombre: 'Pueblorrico',
    codigo: '5.576',
    departamento: 'Antioquia',
    normalizada: 'pueblorrico',
  },
  {
    nombre: 'Puente Nacional',
    codigo: '68.572',
    departamento: 'Santander',
    normalizada: 'puentenacional',
  },
  {
    nombre: 'Puerres',
    codigo: '52.573',
    departamento: 'Nariño',
    normalizada: 'puerres',
  },
  {
    nombre: 'Puerto Alegría',
    codigo: '91.53',
    departamento: 'Amazonas',
    normalizada: 'puertoalegria',
  },
  {
    nombre: 'Puerto Arica',
    codigo: '91.536',
    departamento: 'Amazonas',
    normalizada: 'puertoarica',
  },
  {
    nombre: 'Puerto Asís',
    codigo: '86.568',
    departamento: 'Putumayo',
    normalizada: 'puertoasis',
  },
  {
    nombre: 'Puerto Berrío',
    codigo: '5.579',
    departamento: 'Antioquia',
    normalizada: 'puertoberrio',
  },
  {
    nombre: 'Puerto Boyacá',
    codigo: '15.572',
    departamento: 'Boyacá',
    normalizada: 'puertoboyaca',
  },
  {
    nombre: 'Puerto Caicedo',
    codigo: '86.569',
    departamento: 'Putumayo',
    normalizada: 'puertocaicedo',
  },
  {
    nombre: 'Puerto Carreño',
    codigo: '99.001',
    departamento: 'Vichada',
    normalizada: 'puertocarreno',
  },
  {
    nombre: 'Puerto Colombia',
    codigo: '94.884',
    departamento: 'Guainía',
    normalizada: 'puertocolombia',
  },
  {
    nombre: 'Puerto Colombia',
    codigo: '8.573',
    departamento: 'Atlántico',
    normalizada: 'puertocolombia',
  },
  {
    nombre: 'Puerto Concordia',
    codigo: '50.45',
    departamento: 'Meta',
    normalizada: 'puertoconcordia',
  },
  {
    nombre: 'Puerto Escondido',
    codigo: '23.574',
    departamento: 'Córdoba',
    normalizada: 'puertoescondido',
  },
  {
    nombre: 'Puerto Gaitán',
    codigo: '50.568',
    departamento: 'Meta',
    normalizada: 'puertogaitan',
  },
  {
    nombre: 'Puerto Guzmán',
    codigo: '86.571',
    departamento: 'Putumayo',
    normalizada: 'puertoguzman',
  },
  {
    nombre: 'Puerto Leguízamo',
    codigo: '86.573',
    departamento: 'Putumayo',
    normalizada: 'puertoleguizamo',
  },
  {
    nombre: 'Puerto Libertador',
    codigo: '23.58',
    departamento: 'Córdoba',
    normalizada: 'puertolibertador',
  },
  {
    nombre: 'Puerto Lleras',
    codigo: '50.577',
    departamento: 'Meta',
    normalizada: 'puertolleras',
  },
  {
    nombre: 'Puerto López',
    codigo: '50.573',
    departamento: 'Meta',
    normalizada: 'puertolopez',
  },
  {
    nombre: 'Puerto Nare',
    codigo: '5.585',
    departamento: 'Antioquia',
    normalizada: 'puertonare',
  },
  {
    nombre: 'Puerto Nariño',
    codigo: '91.54',
    departamento: 'Amazonas',
    normalizada: 'puertonarino',
  },
  {
    nombre: 'Puerto Parra',
    codigo: '68.573',
    departamento: 'Santander',
    normalizada: 'puertoparra',
  },
  {
    nombre: 'Puerto Rico',
    codigo: '18.592',
    departamento: 'Caquetá',
    normalizada: 'puertorico',
  },
  {
    nombre: 'Puerto Rico',
    codigo: '50.59',
    departamento: 'Meta',
    normalizada: 'puertorico',
  },
  {
    nombre: 'Puerto Rondón',
    codigo: '81.591',
    departamento: 'Arauca',
    normalizada: 'puertorondon',
  },
  {
    nombre: 'Puerto Salgar',
    codigo: '25.572',
    departamento: 'Cundinamarca',
    normalizada: 'puertosalgar',
  },
  {
    nombre: 'Puerto Santander',
    codigo: '91.669',
    departamento: 'Amazonas',
    normalizada: 'puertosantander',
  },
  {
    nombre: 'Puerto Santander',
    codigo: '54.553',
    departamento: 'Norte de Santander',
    normalizada: 'puertosantander',
  },
  {
    nombre: 'Puerto Tejada',
    codigo: '19.573',
    departamento: 'Cauca',
    normalizada: 'puertotejada',
  },
  {
    nombre: 'Puerto Triunfo',
    codigo: '5.591',
    departamento: 'Antioquia',
    normalizada: 'puertotriunfo',
  },
  {
    nombre: 'Puerto Wilches',
    codigo: '68.575',
    departamento: 'Santander',
    normalizada: 'puertowilches',
  },
  {
    nombre: 'Pulí',
    codigo: '25.58',
    departamento: 'Cundinamarca',
    normalizada: 'puli',
  },
  {
    nombre: 'Pupiales',
    codigo: '52.585',
    departamento: 'Nariño',
    normalizada: 'pupiales',
  },
  {
    nombre: 'Puracé',
    codigo: '19.585',
    departamento: 'Cauca',
    normalizada: 'purace',
  },
  {
    nombre: 'Purificación',
    codigo: '73.585',
    departamento: 'Tolima',
    normalizada: 'purificacion',
  },
  {
    nombre: 'Purísima de La Concepción',
    codigo: '23.586',
    departamento: 'Córdoba',
    normalizada: 'purisimadelaconcepcion',
  },
  {
    nombre: 'Quebradanegra',
    codigo: '25.592',
    departamento: 'Cundinamarca',
    normalizada: 'quebradanegra',
  },
  {
    nombre: 'Quetame',
    codigo: '25.594',
    departamento: 'Cundinamarca',
    normalizada: 'quetame',
  },
  {
    nombre: 'Quibdó',
    codigo: '27.001',
    departamento: 'Chocó',
    normalizada: 'quibdo',
  },
  {
    nombre: 'Quimbaya',
    codigo: '63.594',
    departamento: 'Quindío',
    normalizada: 'quimbaya',
  },
  {
    nombre: 'Quinchía',
    codigo: '66.594',
    departamento: 'Risaralda',
    normalizada: 'quinchia',
  },
  {
    nombre: 'Quípama',
    codigo: '15.58',
    departamento: 'Boyacá',
    normalizada: 'quipama',
  },
  {
    nombre: 'Quipile',
    codigo: '25.596',
    departamento: 'Cundinamarca',
    normalizada: 'quipile',
  },
  {
    nombre: 'Ragonvalia',
    codigo: '54.599',
    departamento: 'Norte de Santander',
    normalizada: 'ragonvalia',
  },
  {
    nombre: 'Ramiriquí',
    codigo: '15.599',
    departamento: 'Boyacá',
    normalizada: 'ramiriqui',
  },
  {
    nombre: 'Ráquira',
    codigo: '15.6',
    departamento: 'Boyacá',
    normalizada: 'raquira',
  },
  {
    nombre: 'Recetor',
    codigo: '85.279',
    departamento: 'Casanare',
    normalizada: 'recetor',
  },
  {
    nombre: 'Regidor',
    codigo: '13.58',
    departamento: 'Bolívar',
    normalizada: 'regidor',
  },
  {
    nombre: 'Remedios',
    codigo: '5.604',
    departamento: 'Antioquia',
    normalizada: 'remedios',
  },
  {
    nombre: 'Remolino',
    codigo: '47.605',
    departamento: 'Magdalena',
    normalizada: 'remolino',
  },
  {
    nombre: 'Repelón',
    codigo: '8.606',
    departamento: 'Atlántico',
    normalizada: 'repelon',
  },
  {
    nombre: 'Restrepo',
    codigo: '50.606',
    departamento: 'Meta',
    normalizada: 'restrepo',
  },
  {
    nombre: 'Restrepo',
    codigo: '76.606',
    departamento: 'Valle del Cauca',
    normalizada: 'restrepo',
  },
  {
    nombre: 'Retiro',
    codigo: '5.607',
    departamento: 'Antioquia',
    normalizada: 'retiro',
  },
  {
    nombre: 'Ricaurte',
    codigo: '25.612',
    departamento: 'Cundinamarca',
    normalizada: 'ricaurte',
  },
  {
    nombre: 'Ricaurte',
    codigo: '52.612',
    departamento: 'Nariño',
    normalizada: 'ricaurte',
  },
  {
    nombre: 'Rio Blanco',
    codigo: '73.616',
    departamento: 'Tolima',
    normalizada: 'rioblanco',
  },
  {
    nombre: 'Río de Oro',
    codigo: '20.614',
    departamento: 'Cesár',
    normalizada: 'riodeoro',
  },
  {
    nombre: 'Río Iró',
    codigo: '27.58',
    departamento: 'Chocó',
    normalizada: 'rioiro',
  },
  {
    nombre: 'Río Quito',
    codigo: '27.6',
    departamento: 'Chocó',
    normalizada: 'rioquito',
  },
  {
    nombre: 'Río Viejo',
    codigo: '13.6',
    departamento: 'Bolívar',
    normalizada: 'rioviejo',
  },
  {
    nombre: 'Riofrío',
    codigo: '76.616',
    departamento: 'Valle del Cauca',
    normalizada: 'riofrio',
  },
  {
    nombre: 'Riohacha',
    codigo: '44.001',
    departamento: 'La Guajira',
    normalizada: 'riohacha',
  },
  {
    nombre: 'Rionegro',
    codigo: '5.615',
    departamento: 'Antioquia',
    normalizada: 'rionegro',
  },
  {
    nombre: 'Rionegro',
    codigo: '68.615',
    departamento: 'Santander',
    normalizada: 'rionegro',
  },
  {
    nombre: 'Riosucio',
    codigo: '17.614',
    departamento: 'Caldas',
    normalizada: 'riosucio',
  },
  {
    nombre: 'Riosucio',
    codigo: '27.615',
    departamento: 'Chocó',
    normalizada: 'riosucio',
  },
  {
    nombre: 'Risaralda',
    codigo: '17.616',
    departamento: 'Caldas',
    normalizada: 'risaralda',
  },
  {
    nombre: 'Rivera',
    codigo: '41.615',
    departamento: 'Huila',
    normalizada: 'rivera',
  },
  {
    nombre: 'Roberto Payán',
    codigo: '52.621',
    departamento: 'Nariño',
    normalizada: 'robertopayan',
  },
  {
    nombre: 'Roldanillo',
    codigo: '76.622',
    departamento: 'Valle del Cauca',
    normalizada: 'roldanillo',
  },
  {
    nombre: 'Roncesvalles',
    codigo: '73.622',
    departamento: 'Tolima',
    normalizada: 'roncesvalles',
  },
  {
    nombre: 'Rondón',
    codigo: '15.621',
    departamento: 'Boyacá',
    normalizada: 'rondon',
  },
  {
    nombre: 'Rosas',
    codigo: '19.622',
    departamento: 'Cauca',
    normalizada: 'rosas',
  },
  {
    nombre: 'Rovira',
    codigo: '73.624',
    departamento: 'Tolima',
    normalizada: 'rovira',
  },
  {
    nombre: 'Sabana de Torres',
    codigo: '68.655',
    departamento: 'Santander',
    normalizada: 'sabanadetorres',
  },
  {
    nombre: 'Sabanagrande',
    codigo: '8.634',
    departamento: 'Atlántico',
    normalizada: 'sabanagrande',
  },
  {
    nombre: 'Sabanalarga',
    codigo: '5.628',
    departamento: 'Antioquia',
    normalizada: 'sabanalarga',
  },
  {
    nombre: 'Sabanalarga',
    codigo: '8.638',
    departamento: 'Atlántico',
    normalizada: 'sabanalarga',
  },
  {
    nombre: 'Sabanalarga',
    codigo: '85.3',
    departamento: 'Casanare',
    normalizada: 'sabanalarga',
  },
  {
    nombre: 'Sabanas de San Ángel',
    codigo: '47.66',
    departamento: 'Magdalena',
    normalizada: 'sabanasdesanangel',
  },
  {
    nombre: 'Sabaneta',
    codigo: '5.631',
    departamento: 'Antioquia',
    normalizada: 'sabaneta',
  },
  {
    nombre: 'Saboyá',
    codigo: '15.632',
    departamento: 'Boyacá',
    normalizada: 'saboya',
  },
  {
    nombre: 'Sácama',
    codigo: '85.315',
    departamento: 'Casanare',
    normalizada: 'sacama',
  },
  {
    nombre: 'Sáchica',
    codigo: '15.638',
    departamento: 'Boyacá',
    normalizada: 'sachica',
  },
  {
    nombre: 'Sahagún',
    codigo: '23.66',
    departamento: 'Córdoba',
    normalizada: 'sahagun',
  },
  {
    nombre: 'Saladoblanco',
    codigo: '41.66',
    departamento: 'Huila',
    normalizada: 'saladoblanco',
  },
  {
    nombre: 'Salamina',
    codigo: '17.653',
    departamento: 'Caldas',
    normalizada: 'salamina',
  },
  {
    nombre: 'Salamina',
    codigo: '47.675',
    departamento: 'Magdalena',
    normalizada: 'salamina',
  },
  {
    nombre: 'Salazar',
    codigo: '54.66',
    departamento: 'Norte de Santander',
    normalizada: 'salazar',
  },
  {
    nombre: 'Saldaña',
    codigo: '73.671',
    departamento: 'Tolima',
    normalizada: 'saldana',
  },
  {
    nombre: 'Salento',
    codigo: '63.69',
    departamento: 'Quindío',
    normalizada: 'salento',
  },
  {
    nombre: 'Salgar',
    codigo: '5.642',
    departamento: 'Antioquia',
    normalizada: 'salgar',
  },
  {
    nombre: 'Samacá',
    codigo: '15.646',
    departamento: 'Boyacá',
    normalizada: 'samaca',
  },
  {
    nombre: 'Samaná',
    codigo: '17.662',
    departamento: 'Caldas',
    normalizada: 'samana',
  },
  {
    nombre: 'Samaniego',
    codigo: '52.678',
    departamento: 'Nariño',
    normalizada: 'samaniego',
  },
  {
    nombre: 'Sampués',
    codigo: '70.67',
    departamento: 'Sucre',
    normalizada: 'sampues',
  },
  {
    nombre: 'San Agustín',
    codigo: '41.668',
    departamento: 'Huila',
    normalizada: 'sanagustin',
  },
  {
    nombre: 'San Alberto',
    codigo: '20.71',
    departamento: 'Cesár',
    normalizada: 'sanalberto',
  },
  {
    nombre: 'San Andrés',
    codigo: '68.669',
    departamento: 'Santander',
    normalizada: 'sanandres',
  },
  {
    nombre: 'San Andrés',
    codigo: '88.001',
    departamento: 'Archipiélago de San Andrés, Providencia y Santa Catalina',
    normalizada: 'sanandres',
  },
  {
    nombre: 'San Andrés de Cuerquía',
    codigo: '5.647',
    departamento: 'Antioquia',
    normalizada: 'sanandresdecuerquia',
  },
  {
    nombre: 'San Andrés de Sotavento',
    codigo: '23.67',
    departamento: 'Córdoba',
    normalizada: 'sanandresdesotavento',
  },
  {
    nombre: 'San Andrés de Tumaco',
    codigo: '52.835',
    departamento: 'Nariño',
    normalizada: 'sanandresdetumaco',
  },
  {
    nombre: 'San Antero',
    codigo: '23.672',
    departamento: 'Córdoba',
    normalizada: 'sanantero',
  },
  {
    nombre: 'San Antonio',
    codigo: '73.675',
    departamento: 'Tolima',
    normalizada: 'sanantonio',
  },
  {
    nombre: 'San Antonio del Tequendama',
    codigo: '25.645',
    departamento: 'Cundinamarca',
    normalizada: 'sanantoniodeltequendama',
  },
  {
    nombre: 'San Benito',
    codigo: '68.673',
    departamento: 'Santander',
    normalizada: 'sanbenito',
  },
  {
    nombre: 'San Benito Abad',
    codigo: '70.678',
    departamento: 'Sucre',
    normalizada: 'sanbenitoabad',
  },
  {
    nombre: 'San Bernardo',
    codigo: '25.649',
    departamento: 'Cundinamarca',
    normalizada: 'sanbernardo',
  },
  {
    nombre: 'San Bernardo',
    codigo: '52.685',
    departamento: 'Nariño',
    normalizada: 'sanbernardo',
  },
  {
    nombre: 'San Bernardo del Viento',
    codigo: '23.675',
    departamento: 'Córdoba',
    normalizada: 'sanbernardodelviento',
  },
  {
    nombre: 'San Calixto',
    codigo: '54.67',
    departamento: 'Norte de Santander',
    normalizada: 'sancalixto',
  },
  {
    nombre: 'San Carlos',
    codigo: '23.678',
    departamento: 'Córdoba',
    normalizada: 'sancarlos',
  },
  {
    nombre: 'San Carlos',
    codigo: '5.649',
    departamento: 'Antioquia',
    normalizada: 'sancarlos',
  },
  {
    nombre: 'San Carlos de Guaroa',
    codigo: '50.68',
    departamento: 'Meta',
    normalizada: 'sancarlosdeguaroa',
  },
  {
    nombre: 'San Cayetano',
    codigo: '25.653',
    departamento: 'Cundinamarca',
    normalizada: 'sancayetano',
  },
  {
    nombre: 'San Cayetano',
    codigo: '54.673',
    departamento: 'Norte de Santander',
    normalizada: 'sancayetano',
  },
  {
    nombre: 'San Cristóbal',
    codigo: '13.62',
    departamento: 'Bolívar',
    normalizada: 'sancristobal',
  },
  {
    nombre: 'San Diego',
    codigo: '20.75',
    departamento: 'Cesár',
    normalizada: 'sandiego',
  },
  {
    nombre: 'San Eduardo',
    codigo: '15.66',
    departamento: 'Boyacá',
    normalizada: 'saneduardo',
  },
  {
    nombre: 'San Estanislao',
    codigo: '13.647',
    departamento: 'Bolívar',
    normalizada: 'sanestanislao',
  },
  {
    nombre: 'San Felipe',
    codigo: '94.883',
    departamento: 'Guainía',
    normalizada: 'sanfelipe',
  },
  {
    nombre: 'San Fernando',
    codigo: '13.65',
    departamento: 'Bolívar',
    normalizada: 'sanfernando',
  },
  {
    nombre: 'San Francisco',
    codigo: '5.652',
    departamento: 'Antioquia',
    normalizada: 'sanfrancisco',
  },
  {
    nombre: 'San Francisco',
    codigo: '25.658',
    departamento: 'Cundinamarca',
    normalizada: 'sanfrancisco',
  },
  {
    nombre: 'San Francisco',
    codigo: '86.755',
    departamento: 'Putumayo',
    normalizada: 'sanfrancisco',
  },
  {
    nombre: 'San Gil',
    codigo: '68.679',
    departamento: 'Santander',
    normalizada: 'sangil',
  },
  {
    nombre: 'San Jacinto',
    codigo: '13.654',
    departamento: 'Bolívar',
    normalizada: 'sanjacinto',
  },
  {
    nombre: 'San Jacinto del Cauca',
    codigo: '13.655',
    departamento: 'Bolívar',
    normalizada: 'sanjacintodelcauca',
  },
  {
    nombre: 'San Jerónimo',
    codigo: '5.656',
    departamento: 'Antioquia',
    normalizada: 'sanjeronimo',
  },
  {
    nombre: 'San Joaquín',
    codigo: '68.682',
    departamento: 'Santander',
    normalizada: 'sanjoaquin',
  },
  {
    nombre: 'San José',
    codigo: '17.665',
    departamento: 'Caldas',
    normalizada: 'sanjose',
  },
  {
    nombre: 'San José de La Montaña',
    codigo: '5.658',
    departamento: 'Antioquia',
    normalizada: 'sanjosedelamontana',
  },
  {
    nombre: 'San José de Miranda',
    codigo: '68.684',
    departamento: 'Santander',
    normalizada: 'sanjosedemiranda',
  },
  {
    nombre: 'San José de Pare',
    codigo: '15.664',
    departamento: 'Boyacá',
    normalizada: 'sanjosedepare',
  },
  {
    nombre: 'San José de Uré',
    codigo: '23.682',
    departamento: 'Córdoba',
    normalizada: 'sanjosedeure',
  },
  {
    nombre: 'San José del Fragua',
    codigo: '18.61',
    departamento: 'Caquetá',
    normalizada: 'sanjosedelfragua',
  },
  {
    nombre: 'San José del Guaviare',
    codigo: '95.001',
    departamento: 'Guaviare',
    normalizada: 'sanjosedelguaviare',
  },
  {
    nombre: 'San José del Palmar',
    codigo: '27.66',
    departamento: 'Chocó',
    normalizada: 'sanjosedelpalmar',
  },
  {
    nombre: 'San Juan de Arama',
    codigo: '50.683',
    departamento: 'Meta',
    normalizada: 'sanjuandearama',
  },
  {
    nombre: 'San Juan de Betulia',
    codigo: '70.702',
    departamento: 'Sucre',
    normalizada: 'sanjuandebetulia',
  },
  {
    nombre: 'San Juan de Río Seco',
    codigo: '25.662',
    departamento: 'Cundinamarca',
    normalizada: 'sanjuanderioseco',
  },
  {
    nombre: 'San Juan de Urabá',
    codigo: '5.659',
    departamento: 'Antioquia',
    normalizada: 'sanjuandeuraba',
  },
  {
    nombre: 'San Juan del Cesár',
    codigo: '44.65',
    departamento: 'La Guajira',
    normalizada: 'sanjuandelCesár',
  },
  {
    nombre: 'San Juan Nepomuceno',
    codigo: '13.657',
    departamento: 'Bolívar',
    normalizada: 'sanjuannepomuceno',
  },
  {
    nombre: 'San Juanito',
    codigo: '50.686',
    departamento: 'Meta',
    normalizada: 'sanjuanito',
  },
  {
    nombre: 'San Lorenzo',
    codigo: '52.687',
    departamento: 'Nariño',
    normalizada: 'sanlorenzo',
  },
  {
    nombre: 'San Luis',
    codigo: '5.66',
    departamento: 'Antioquia',
    normalizada: 'sanluis',
  },
  {
    nombre: 'San Luis',
    codigo: '73.678',
    departamento: 'Tolima',
    normalizada: 'sanluis',
  },
  {
    nombre: 'San Luis de Gaceno',
    codigo: '15.667',
    departamento: 'Boyacá',
    normalizada: 'sanluisdegaceno',
  },
  {
    nombre: 'San Luis de Palenque',
    codigo: '85.325',
    departamento: 'Casanare',
    normalizada: 'sanluisdepalenque',
  },
  {
    nombre: 'San Luis de Sincé',
    codigo: '70.742',
    departamento: 'Sucre',
    normalizada: 'sanluisdesince',
  },
  {
    nombre: 'San Marcos',
    codigo: '70.708',
    departamento: 'Sucre',
    normalizada: 'sanmarcos',
  },
  {
    nombre: 'San Martín',
    codigo: '20.77',
    departamento: 'Cesár',
    normalizada: 'sanmartin',
  },
  {
    nombre: 'San Martín',
    codigo: '50.689',
    departamento: 'Meta',
    normalizada: 'sanmartin',
  },
  {
    nombre: 'San Martín de Loba',
    codigo: '13.667',
    departamento: 'Bolívar',
    normalizada: 'sanmartindeloba',
  },
  {
    nombre: 'San Mateo',
    codigo: '15.673',
    departamento: 'Boyacá',
    normalizada: 'sanmateo',
  },
  {
    nombre: 'San Miguel',
    codigo: '68.686',
    departamento: 'Santander',
    normalizada: 'sanmiguel',
  },
  {
    nombre: 'San Miguel',
    codigo: '86.757',
    departamento: 'Putumayo',
    normalizada: 'sanmiguel',
  },
  {
    nombre: 'San Miguel de Sema',
    codigo: '15.676',
    departamento: 'Boyacá',
    normalizada: 'sanmigueldesema',
  },
  {
    nombre: 'San Onofre',
    codigo: '70.713',
    departamento: 'Sucre',
    normalizada: 'sanonofre',
  },
  {
    nombre: 'San Pablo',
    codigo: '52.693',
    departamento: 'Nariño',
    normalizada: 'sanpablo',
  },
  {
    nombre: 'San Pablo',
    codigo: '13.67',
    departamento: 'Bolívar',
    normalizada: 'sanpablo',
  },
  {
    nombre: 'San Pablo de Borbur',
    codigo: '15.681',
    departamento: 'Boyacá',
    normalizada: 'sanpablodeborbur',
  },
  {
    nombre: 'San Pedro',
    codigo: '70.717',
    departamento: 'Sucre',
    normalizada: 'sanpedro',
  },
  {
    nombre: 'San Pedro',
    codigo: '76.67',
    departamento: 'Valle del Cauca',
    normalizada: 'sanpedro',
  },
  {
    nombre: 'San Pedro de Cartago',
    codigo: '52.694',
    departamento: 'Nariño',
    normalizada: 'sanpedrodecartago',
  },
  {
    nombre: 'San Pedro de Los Milagros',
    codigo: '5.664',
    departamento: 'Antioquia',
    normalizada: 'sanpedrodelosmilagros',
  },
  {
    nombre: 'San Pedro de Urabá',
    codigo: '5.665',
    departamento: 'Antioquia',
    normalizada: 'sanpedrodeuraba',
  },
  {
    nombre: 'San Pelayo',
    codigo: '23.686',
    departamento: 'Córdoba',
    normalizada: 'sanpelayo',
  },
  {
    nombre: 'San Rafael',
    codigo: '5.667',
    departamento: 'Antioquia',
    normalizada: 'sanrafael',
  },
  {
    nombre: 'San Roque',
    codigo: '5.67',
    departamento: 'Antioquia',
    normalizada: 'sanroque',
  },
  {
    nombre: 'San Sebastián',
    codigo: '19.693',
    departamento: 'Cauca',
    normalizada: 'sansebastian',
  },
  {
    nombre: 'San Sebastián de Buenavista',
    codigo: '47.692',
    departamento: 'Magdalena',
    normalizada: 'sansebastiandebuenavista',
  },
  {
    nombre: 'San Vicente de Chucurí',
    codigo: '68.689',
    departamento: 'Santander',
    normalizada: 'sanvicentedechucuri',
  },
  {
    nombre: 'San Vicente del Caguán',
    codigo: '18.753',
    departamento: 'Caquetá',
    normalizada: 'sanvicentedelcaguan',
  },
  {
    nombre: 'San Vicente Ferrer',
    codigo: '5.674',
    departamento: 'Antioquia',
    normalizada: 'sanvicenteferrer',
  },
  {
    nombre: 'San Zenón',
    codigo: '47.703',
    departamento: 'Magdalena',
    normalizada: 'sanzenon',
  },
  {
    nombre: 'Sandoná',
    codigo: '52.683',
    departamento: 'Nariño',
    normalizada: 'sandona',
  },
  {
    nombre: 'Santa Ana',
    codigo: '47.707',
    departamento: 'Magdalena',
    normalizada: 'santaana',
  },
  {
    nombre: 'Santa Bárbara',
    codigo: '5.679',
    departamento: 'Antioquia',
    normalizada: 'santabarbara',
  },
  {
    nombre: 'Santa Bárbara',
    codigo: '52.696',
    departamento: 'Nariño',
    normalizada: 'santabarbara',
  },
  {
    nombre: 'Santa Bárbara',
    codigo: '68.705',
    departamento: 'Santander',
    normalizada: 'santabarbara',
  },
  {
    nombre: 'Santa Bárbara de Pinto',
    codigo: '47.72',
    departamento: 'Magdalena',
    normalizada: 'santabarbaradepinto',
  },
  {
    nombre: 'Santa Catalina',
    codigo: '13.673',
    departamento: 'Bolívar',
    normalizada: 'santacatalina',
  },
  {
    nombre: 'Santa Cruz de Mompox',
    codigo: '13.468',
    departamento: 'Bolívar',
    normalizada: 'santacruzdemompox',
  },
  {
    nombre: 'Santa Fé de Antioquia',
    codigo: '5.042',
    departamento: 'Antioquia',
    normalizada: 'santafedeantioquia',
  },
  {
    nombre: 'Santa Helena del Opón',
    codigo: '68.72',
    departamento: 'Santander',
    normalizada: 'santahelenadelopon',
  },
  {
    nombre: 'Santa Isabel',
    codigo: '73.686',
    departamento: 'Tolima',
    normalizada: 'santaisabel',
  },
  {
    nombre: 'Santa Lucía',
    codigo: '8.675',
    departamento: 'Atlántico',
    normalizada: 'santalucia',
  },
  {
    nombre: 'Santa María',
    codigo: '15.69',
    departamento: 'Boyacá',
    normalizada: 'santamaria',
  },
  {
    nombre: 'Santa María',
    codigo: '41.676',
    departamento: 'Huila',
    normalizada: 'santamaria',
  },
  {
    nombre: 'Santa Marta',
    codigo: '47.001',
    departamento: 'Magdalena',
    normalizada: 'santamarta',
  },
  {
    nombre: 'Santa Rosa',
    codigo: '13.683',
    departamento: 'Bolívar',
    normalizada: 'santarosa',
  },
  {
    nombre: 'Santa Rosa',
    codigo: '19.701',
    departamento: 'Cauca',
    normalizada: 'santarosa',
  },
  {
    nombre: 'Santa Rosa de Cabal',
    codigo: '66.682',
    departamento: 'Risaralda',
    normalizada: 'santarosadecabal',
  },
  {
    nombre: 'Santa Rosa de Osos',
    codigo: '5.686',
    departamento: 'Antioquia',
    normalizada: 'santarosadeosos',
  },
  {
    nombre: 'Santa Rosa de Viterbo',
    codigo: '15.693',
    departamento: 'Boyacá',
    normalizada: 'santarosadeviterbo',
  },
  {
    nombre: 'Santa Rosa del Sur',
    codigo: '13.688',
    departamento: 'Bolívar',
    normalizada: 'santarosadelsur',
  },
  {
    nombre: 'Santa Rosalía',
    codigo: '99.624',
    departamento: 'Vichada',
    normalizada: 'santarosalia',
  },
  {
    nombre: 'Santa Sofía',
    codigo: '15.696',
    departamento: 'Boyacá',
    normalizada: 'santasofia',
  },
  {
    nombre: 'Santacruz',
    codigo: '52.699',
    departamento: 'Nariño',
    normalizada: 'santacruz',
  },
  {
    nombre: 'Santana',
    codigo: '15.686',
    departamento: 'Boyacá',
    normalizada: 'santana',
  },
  {
    nombre: 'Santander de Quilichao',
    codigo: '19.698',
    departamento: 'Cauca',
    normalizada: 'santanderdequilichao',
  },
  {
    nombre: 'Santiago',
    codigo: '86.76',
    departamento: 'Putumayo',
    normalizada: 'santiago',
  },
  {
    nombre: 'Santiago',
    codigo: '54.68',
    departamento: 'Norte de Santander',
    normalizada: 'santiago',
  },
  {
    nombre: 'Santiago de Tolú',
    codigo: '70.82',
    departamento: 'Sucre',
    normalizada: 'santiagodetolu',
  },
  {
    nombre: 'Santo Domingo',
    codigo: '5.69',
    departamento: 'Antioquia',
    normalizada: 'santodomingo',
  },
  {
    nombre: 'Santo Tomás',
    codigo: '8.685',
    departamento: 'Atlántico',
    normalizada: 'santotomas',
  },
  {
    nombre: 'Santuario',
    codigo: '66.687',
    departamento: 'Risaralda',
    normalizada: 'santuario',
  },
  {
    nombre: 'Sapuyes',
    codigo: '52.72',
    departamento: 'Nariño',
    normalizada: 'sapuyes',
  },
  {
    nombre: 'Saravena',
    codigo: '81.736',
    departamento: 'Arauca',
    normalizada: 'saravena',
  },
  {
    nombre: 'Sardinata',
    codigo: '54.72',
    departamento: 'Norte de Santander',
    normalizada: 'sardinata',
  },
  {
    nombre: 'Sasaima',
    codigo: '25.718',
    departamento: 'Cundinamarca',
    normalizada: 'sasaima',
  },
  {
    nombre: 'Sativanorte',
    codigo: '15.72',
    departamento: 'Boyacá',
    normalizada: 'sativanorte',
  },
  {
    nombre: 'Sativasur',
    codigo: '15.723',
    departamento: 'Boyacá',
    normalizada: 'sativasur',
  },
  {
    nombre: 'Segovia',
    codigo: '5.736',
    departamento: 'Antioquia',
    normalizada: 'segovia',
  },
  {
    nombre: 'Sesquilé',
    codigo: '25.736',
    departamento: 'Cundinamarca',
    normalizada: 'sesquile',
  },
  {
    nombre: 'Sevilla',
    codigo: '76.736',
    departamento: 'Valle del Cauca',
    normalizada: 'sevilla',
  },
  {
    nombre: 'Siachoque',
    codigo: '15.74',
    departamento: 'Boyacá',
    normalizada: 'siachoque',
  },
  {
    nombre: 'Sibaté',
    codigo: '25.74',
    departamento: 'Cundinamarca',
    normalizada: 'sibate',
  },
  {
    nombre: 'Sibundoy',
    codigo: '86.749',
    departamento: 'Putumayo',
    normalizada: 'sibundoy',
  },
  {
    nombre: 'Silos',
    codigo: '54.743',
    departamento: 'Norte de Santander',
    normalizada: 'silos',
  },
  {
    nombre: 'Silvania',
    codigo: '25.743',
    departamento: 'Cundinamarca',
    normalizada: 'silvania',
  },
  {
    nombre: 'Silvia',
    codigo: '19.743',
    departamento: 'Cauca',
    normalizada: 'silvia',
  },
  {
    nombre: 'Simacota',
    codigo: '68.745',
    departamento: 'Santander',
    normalizada: 'simacota',
  },
  {
    nombre: 'Simijaca',
    codigo: '25.745',
    departamento: 'Cundinamarca',
    normalizada: 'simijaca',
  },
  {
    nombre: 'Simití',
    codigo: '13.744',
    departamento: 'Bolívar',
    normalizada: 'simiti',
  },
  {
    nombre: 'Sincelejo',
    codigo: '70.001',
    departamento: 'Sucre',
    normalizada: 'sincelejo',
  },
  {
    nombre: 'Sipí',
    codigo: '27.745',
    departamento: 'Chocó',
    normalizada: 'sipi',
  },
  {
    nombre: 'Sitionuevo',
    codigo: '47.745',
    departamento: 'Magdalena',
    normalizada: 'sitionuevo',
  },
  {
    nombre: 'Soacha',
    codigo: '25.754',
    departamento: 'Cundinamarca',
    normalizada: 'soacha',
  },
  {
    nombre: 'Soatá',
    codigo: '15.753',
    departamento: 'Boyacá',
    normalizada: 'soata',
  },
  {
    nombre: 'Socha',
    codigo: '15.757',
    departamento: 'Boyacá',
    normalizada: 'socha',
  },
  {
    nombre: 'Socorro',
    codigo: '68.755',
    departamento: 'Santander',
    normalizada: 'socorro',
  },
  {
    nombre: 'Socotá',
    codigo: '15.755',
    departamento: 'Boyacá',
    normalizada: 'socota',
  },
  {
    nombre: 'Sogamoso',
    codigo: '15.759',
    departamento: 'Boyacá',
    normalizada: 'sogamoso',
  },
  {
    nombre: 'Solano',
    codigo: '18.756',
    departamento: 'Caquetá',
    normalizada: 'solano',
  },
  {
    nombre: 'Soledad',
    codigo: '8.758',
    departamento: 'Atlántico',
    normalizada: 'soledad',
  },
  {
    nombre: 'Solita',
    codigo: '18.785',
    departamento: 'Caquetá',
    normalizada: 'solita',
  },
  {
    nombre: 'Somondoco',
    codigo: '15.761',
    departamento: 'Boyacá',
    normalizada: 'somondoco',
  },
  {
    nombre: 'Sonsón',
    codigo: '5.756',
    departamento: 'Antioquia',
    normalizada: 'sonson',
  },
  {
    nombre: 'Sopetrán',
    codigo: '5.761',
    departamento: 'Antioquia',
    normalizada: 'sopetran',
  },
  {
    nombre: 'Soplaviento',
    codigo: '13.76',
    departamento: 'Bolívar',
    normalizada: 'soplaviento',
  },
  {
    nombre: 'Sopó',
    codigo: '25.758',
    departamento: 'Cundinamarca',
    normalizada: 'sopo',
  },
  {
    nombre: 'Sora',
    codigo: '15.762',
    departamento: 'Boyacá',
    normalizada: 'sora',
  },
  {
    nombre: 'Soracá',
    codigo: '15.764',
    departamento: 'Boyacá',
    normalizada: 'soraca',
  },
  {
    nombre: 'Sotaquirá',
    codigo: '15.763',
    departamento: 'Boyacá',
    normalizada: 'sotaquira',
  },
  {
    nombre: 'Sotará',
    codigo: '19.76',
    departamento: 'Cauca',
    normalizada: 'sotara',
  },
  {
    nombre: 'Suaita',
    codigo: '68.77',
    departamento: 'Santander',
    normalizada: 'suaita',
  },
  {
    nombre: 'Suan',
    codigo: '8.77',
    departamento: 'Atlántico',
    normalizada: 'suan',
  },
  {
    nombre: 'Suárez',
    codigo: '19.78',
    departamento: 'Cauca',
    normalizada: 'suarez',
  },
  {
    nombre: 'Suárez',
    codigo: '73.77',
    departamento: 'Tolima',
    normalizada: 'suarez',
  },
  {
    nombre: 'Suaza',
    codigo: '41.77',
    departamento: 'Huila',
    normalizada: 'suaza',
  },
  {
    nombre: 'Subachoque',
    codigo: '25.769',
    departamento: 'Cundinamarca',
    normalizada: 'subachoque',
  },
  {
    nombre: 'Sucre',
    codigo: '19.785',
    departamento: 'Cauca',
    normalizada: 'sucre',
  },
  {
    nombre: 'Sucre',
    codigo: '68.773',
    departamento: 'Santander',
    normalizada: 'sucre',
  },
  {
    nombre: 'Sucre',
    codigo: '70.771',
    departamento: 'Sucre',
    normalizada: 'sucre',
  },
  {
    nombre: 'Suesca',
    codigo: '25.772',
    departamento: 'Cundinamarca',
    normalizada: 'suesca',
  },
  {
    nombre: 'Supatá',
    codigo: '25.777',
    departamento: 'Cundinamarca',
    normalizada: 'supata',
  },
  {
    nombre: 'Supía',
    codigo: '17.777',
    departamento: 'Caldas',
    normalizada: 'supia',
  },
  {
    nombre: 'Suratá',
    codigo: '68.78',
    departamento: 'Santander',
    normalizada: 'surata',
  },
  {
    nombre: 'Susa',
    codigo: '25.779',
    departamento: 'Cundinamarca',
    normalizada: 'susa',
  },
  {
    nombre: 'Susacón',
    codigo: '15.774',
    departamento: 'Boyacá',
    normalizada: 'susacon',
  },
  {
    nombre: 'Sutamarchán',
    codigo: '15.776',
    departamento: 'Boyacá',
    normalizada: 'sutamarchan',
  },
  {
    nombre: 'Sutatausa',
    codigo: '25.781',
    departamento: 'Cundinamarca',
    normalizada: 'sutatausa',
  },
  {
    nombre: 'Sutatenza',
    codigo: '15.778',
    departamento: 'Boyacá',
    normalizada: 'sutatenza',
  },
  {
    nombre: 'Tabio',
    codigo: '25.785',
    departamento: 'Cundinamarca',
    normalizada: 'tabio',
  },
  {
    nombre: 'Tadó',
    codigo: '27.787',
    departamento: 'Chocó',
    normalizada: 'tado',
  },
  {
    nombre: 'Talaigua Nuevo',
    codigo: '13.78',
    departamento: 'Bolívar',
    normalizada: 'talaiguanuevo',
  },
  {
    nombre: 'Tamalameque',
    codigo: '20.787',
    departamento: 'Cesár',
    normalizada: 'tamalameque',
  },
  {
    nombre: 'Támara',
    codigo: '85.4',
    departamento: 'Casanare',
    normalizada: 'tamara',
  },
  {
    nombre: 'Tame',
    codigo: '81.794',
    departamento: 'Arauca',
    normalizada: 'tame',
  },
  {
    nombre: 'Támesis',
    codigo: '5.789',
    departamento: 'Antioquia',
    normalizada: 'tamesis',
  },
  {
    nombre: 'Taminango',
    codigo: '52.786',
    departamento: 'Nariño',
    normalizada: 'taminango',
  },
  {
    nombre: 'Tangua',
    codigo: '52.788',
    departamento: 'Nariño',
    normalizada: 'tangua',
  },
  {
    nombre: 'Taraira',
    codigo: '97.666',
    departamento: 'Vaupés',
    normalizada: 'taraira',
  },
  {
    nombre: 'Tarapacá',
    codigo: '91.798',
    departamento: 'Amazonas',
    normalizada: 'tarapaca',
  },
  {
    nombre: 'Tarazá',
    codigo: '5.79',
    departamento: 'Antioquia',
    normalizada: 'taraza',
  },
  {
    nombre: 'Tarqui',
    codigo: '41.791',
    departamento: 'Huila',
    normalizada: 'tarqui',
  },
  {
    nombre: 'Tarso',
    codigo: '5.792',
    departamento: 'Antioquia',
    normalizada: 'tarso',
  },
  {
    nombre: 'Tasco',
    codigo: '15.79',
    departamento: 'Boyacá',
    normalizada: 'tasco',
  },
  {
    nombre: 'Tauramena',
    codigo: '85.41',
    departamento: 'Casanare',
    normalizada: 'tauramena',
  },
  {
    nombre: 'Tausa',
    codigo: '25.793',
    departamento: 'Cundinamarca',
    normalizada: 'tausa',
  },
  {
    nombre: 'Tello',
    codigo: '41.799',
    departamento: 'Huila',
    normalizada: 'tello',
  },
  {
    nombre: 'Tena',
    codigo: '25.797',
    departamento: 'Cundinamarca',
    normalizada: 'tena',
  },
  {
    nombre: 'Tenerife',
    codigo: '47.798',
    departamento: 'Magdalena',
    normalizada: 'tenerife',
  },
  {
    nombre: 'Tenjo',
    codigo: '25.799',
    departamento: 'Cundinamarca',
    normalizada: 'tenjo',
  },
  {
    nombre: 'Tenza',
    codigo: '15.798',
    departamento: 'Boyacá',
    normalizada: 'tenza',
  },
  {
    nombre: 'Teorama',
    codigo: '54.8',
    departamento: 'Norte de Santander',
    normalizada: 'teorama',
  },
  {
    nombre: 'Teruel',
    codigo: '41.801',
    departamento: 'Huila',
    normalizada: 'teruel',
  },
  {
    nombre: 'Tesalia',
    codigo: '41.797',
    departamento: 'Huila',
    normalizada: 'tesalia',
  },
  {
    nombre: 'Tibacuy',
    codigo: '25.805',
    departamento: 'Cundinamarca',
    normalizada: 'tibacuy',
  },
  {
    nombre: 'Tibaná',
    codigo: '15.804',
    departamento: 'Boyacá',
    normalizada: 'tibana',
  },
  {
    nombre: 'Tibasosa',
    codigo: '15.806',
    departamento: 'Boyacá',
    normalizada: 'tibasosa',
  },
  {
    nombre: 'Tibirita',
    codigo: '25.807',
    departamento: 'Cundinamarca',
    normalizada: 'tibirita',
  },
  {
    nombre: 'Tibú',
    codigo: '54.81',
    departamento: 'Norte de Santander',
    normalizada: 'tibu',
  },
  {
    nombre: 'Tierralta',
    codigo: '23.807',
    departamento: 'Córdoba',
    normalizada: 'tierralta',
  },
  {
    nombre: 'Timaná',
    codigo: '41.807',
    departamento: 'Huila',
    normalizada: 'timana',
  },
  {
    nombre: 'Timbío',
    codigo: '19.807',
    departamento: 'Cauca',
    normalizada: 'timbio',
  },
  {
    nombre: 'Timbiquí',
    codigo: '19.809',
    departamento: 'Cauca',
    normalizada: 'timbiqui',
  },
  {
    nombre: 'Tinjacá',
    codigo: '15.808',
    departamento: 'Boyacá',
    normalizada: 'tinjaca',
  },
  {
    nombre: 'Tipacoque',
    codigo: '15.81',
    departamento: 'Boyacá',
    normalizada: 'tipacoque',
  },
  {
    nombre: 'Tiquisio',
    codigo: '13.81',
    departamento: 'Bolívar',
    normalizada: 'tiquisio',
  },
  {
    nombre: 'Titiribí',
    codigo: '5.809',
    departamento: 'Antioquia',
    normalizada: 'titiribi',
  },
  {
    nombre: 'Toca',
    codigo: '15.814',
    departamento: 'Boyacá',
    normalizada: 'toca',
  },
  {
    nombre: 'Tocaima',
    codigo: '25.815',
    departamento: 'Cundinamarca',
    normalizada: 'tocaima',
  },
  {
    nombre: 'Tocancipá',
    codigo: '25.817',
    departamento: 'Cundinamarca',
    normalizada: 'tocancipa',
  },
  {
    nombre: 'Togüí',
    codigo: '15.816',
    departamento: 'Boyacá',
    normalizada: 'togui',
  },
  {
    nombre: 'Toledo',
    codigo: '5.819',
    departamento: 'Antioquia',
    normalizada: 'toledo',
  },
  {
    nombre: 'Toledo',
    codigo: '54.82',
    departamento: 'Norte de Santander',
    normalizada: 'toledo',
  },
  {
    nombre: 'Toluviejo',
    codigo: '70.823',
    departamento: 'Sucre',
    normalizada: 'toluviejo',
  },
  {
    nombre: 'Tona',
    codigo: '68.82',
    departamento: 'Santander',
    normalizada: 'tona',
  },
  {
    nombre: 'Tópaga',
    codigo: '15.82',
    departamento: 'Boyacá',
    normalizada: 'topaga',
  },
  {
    nombre: 'Topaipí',
    codigo: '25.823',
    departamento: 'Cundinamarca',
    normalizada: 'topaipi',
  },
  {
    nombre: 'Toribío',
    codigo: '19.821',
    departamento: 'Cauca',
    normalizada: 'toribio',
  },
  {
    nombre: 'Toro',
    codigo: '76.823',
    departamento: 'Valle del Cauca',
    normalizada: 'toro',
  },
  {
    nombre: 'Tota',
    codigo: '15.822',
    departamento: 'Boyacá',
    normalizada: 'tota',
  },
  {
    nombre: 'Totoró',
    codigo: '19.824',
    departamento: 'Cauca',
    normalizada: 'totoro',
  },
  {
    nombre: 'Trinidad',
    codigo: '85.43',
    departamento: 'Casanare',
    normalizada: 'trinidad',
  },
  {
    nombre: 'Trujillo',
    codigo: '76.828',
    departamento: 'Valle del Cauca',
    normalizada: 'trujillo',
  },
  {
    nombre: 'Tubará',
    codigo: '8.832',
    departamento: 'Atlántico',
    normalizada: 'tubara',
  },
  {
    nombre: 'Tuchín',
    codigo: '23.815',
    departamento: 'Córdoba',
    normalizada: 'tuchin',
  },
  {
    nombre: 'Tuluá',
    codigo: '76.834',
    departamento: 'Valle del Cauca',
    normalizada: 'tulua',
  },
  {
    nombre: 'Tunja',
    codigo: '15.001',
    departamento: 'Boyacá',
    normalizada: 'tunja',
  },
  {
    nombre: 'Tununguá',
    codigo: '15.832',
    departamento: 'Boyacá',
    normalizada: 'tunungua',
  },
  {
    nombre: 'Túquerres',
    codigo: '52.838',
    departamento: 'Nariño',
    normalizada: 'tuquerres',
  },
  {
    nombre: 'Turbaco',
    codigo: '13.836',
    departamento: 'Bolívar',
    normalizada: 'turbaco',
  },
  {
    nombre: 'Turbaná',
    codigo: '13.838',
    departamento: 'Bolívar',
    normalizada: 'turbana',
  },
  {
    nombre: 'Turbo',
    codigo: '5.837',
    departamento: 'Antioquia',
    normalizada: 'turbo',
  },
  {
    nombre: 'Turmequé',
    codigo: '15.835',
    departamento: 'Boyacá',
    normalizada: 'turmeque',
  },
  {
    nombre: 'Tuta',
    codigo: '15.837',
    departamento: 'Boyacá',
    normalizada: 'tuta',
  },
  {
    nombre: 'Tutazá',
    codigo: '15.839',
    departamento: 'Boyacá',
    normalizada: 'tutaza',
  },
  {
    nombre: 'Ubalá',
    codigo: '25.839',
    departamento: 'Cundinamarca',
    normalizada: 'ubala',
  },
  {
    nombre: 'Ubaque',
    codigo: '25.841',
    departamento: 'Cundinamarca',
    normalizada: 'ubaque',
  },
  {
    nombre: 'Ubaté',
    codigo: '25.843',
    departamento: 'Cundinamarca',
    normalizada: 'ubate',
  },
  {
    nombre: 'Ulloa',
    codigo: '76.845',
    departamento: 'Valle del Cauca',
    normalizada: 'ulloa',
  },
  {
    nombre: 'Úmbita',
    codigo: '15.842',
    departamento: 'Boyacá',
    normalizada: 'umbita',
  },
  {
    nombre: 'Une',
    codigo: '25.845',
    departamento: 'Cundinamarca',
    normalizada: 'une',
  },
  {
    nombre: 'Unguía',
    codigo: '27.8',
    departamento: 'Chocó',
    normalizada: 'unguia',
  },
  {
    nombre: 'Unión Panamericana',
    codigo: '27.81',
    departamento: 'Chocó',
    normalizada: 'unionpanamericana',
  },
  {
    nombre: 'Uramita',
    codigo: '5.842',
    departamento: 'Antioquia',
    normalizada: 'uramita',
  },
  {
    nombre: 'Uribe',
    codigo: '50.37',
    departamento: 'Meta',
    normalizada: 'uribe',
  },
  {
    nombre: 'Uribia',
    codigo: '44.847',
    departamento: 'La Guajira',
    normalizada: 'uribia',
  },
  {
    nombre: 'Urrao',
    codigo: '5.847',
    departamento: 'Antioquia',
    normalizada: 'urrao',
  },
  {
    nombre: 'Urumita',
    codigo: '44.855',
    departamento: 'La Guajira',
    normalizada: 'urumita',
  },
  {
    nombre: 'Usiacurí',
    codigo: '8.849',
    departamento: 'Atlántico',
    normalizada: 'usiacuri',
  },
  {
    nombre: 'Útica',
    codigo: '25.851',
    departamento: 'Cundinamarca',
    normalizada: 'utica',
  },
  {
    nombre: 'Valdivia',
    codigo: '5.854',
    departamento: 'Antioquia',
    normalizada: 'valdivia',
  },
  {
    nombre: 'Valencia',
    codigo: '23.855',
    departamento: 'Córdoba',
    normalizada: 'valencia',
  },
  {
    nombre: 'Valle de San José',
    codigo: '68.855',
    departamento: 'Santander',
    normalizada: 'valledesanjose',
  },
  {
    nombre: 'Valle de San Juan',
    codigo: '73.854',
    departamento: 'Tolima',
    normalizada: 'valledesanjuan',
  },
  {
    nombre: 'Valle del Guamuez',
    codigo: '86.865',
    departamento: 'Putumayo',
    normalizada: 'valledelguamuez',
  },
  {
    nombre: 'Valledupar',
    codigo: '20.001',
    departamento: 'Cesár',
    normalizada: 'valledupar',
  },
  {
    nombre: 'Valparaíso',
    codigo: '5.856',
    departamento: 'Antioquia',
    normalizada: 'valparaiso',
  },
  {
    nombre: 'Valparaíso',
    codigo: '18.86',
    departamento: 'Caquetá',
    normalizada: 'valparaiso',
  },
  {
    nombre: 'Vegachí',
    codigo: '5.858',
    departamento: 'Antioquia',
    normalizada: 'vegachi',
  },
  {
    nombre: 'Vélez',
    codigo: '68.861',
    departamento: 'Santander',
    normalizada: 'velez',
  },
  {
    nombre: 'Venadillo',
    codigo: '73.861',
    departamento: 'Tolima',
    normalizada: 'venadillo',
  },
  {
    nombre: 'Venecia',
    codigo: '5.861',
    departamento: 'Antioquia',
    normalizada: 'venecia',
  },
  {
    nombre: 'Venecia',
    codigo: '25.506',
    departamento: 'Cundinamarca',
    normalizada: 'venecia',
  },
  {
    nombre: 'Ventaquemada',
    codigo: '15.861',
    departamento: 'Boyacá',
    normalizada: 'ventaquemada',
  },
  {
    nombre: 'Vergara',
    codigo: '25.862',
    departamento: 'Cundinamarca',
    normalizada: 'vergara',
  },
  {
    nombre: 'Versalles',
    codigo: '76.863',
    departamento: 'Valle del Cauca',
    normalizada: 'versalles',
  },
  {
    nombre: 'Vetas',
    codigo: '68.867',
    departamento: 'Santander',
    normalizada: 'vetas',
  },
  {
    nombre: 'Vianí',
    codigo: '25.867',
    departamento: 'Cundinamarca',
    normalizada: 'viani',
  },
  {
    nombre: 'Victoria',
    codigo: '17.867',
    departamento: 'Caldas',
    normalizada: 'victoria',
  },
  {
    nombre: 'Vigía del Fuerte',
    codigo: '5.873',
    departamento: 'Antioquia',
    normalizada: 'vigiadelfuerte',
  },
  {
    nombre: 'Vijes',
    codigo: '76.869',
    departamento: 'Valle del Cauca',
    normalizada: 'vijes',
  },
  {
    nombre: 'Villa Caro',
    codigo: '54.871',
    departamento: 'Norte de Santander',
    normalizada: 'villacaro',
  },
  {
    nombre: 'Villa de Leyva',
    codigo: '15.407',
    departamento: 'Boyacá',
    normalizada: 'villadeleyva',
  },
  {
    nombre: 'Villa del Rosario',
    codigo: '54.874',
    departamento: 'Norte de Santander',
    normalizada: 'villadelrosario',
  },
  {
    nombre: 'Villa Rica',
    codigo: '19.845',
    departamento: 'Cauca',
    normalizada: 'villarica',
  },
  {
    nombre: 'Villagarzón',
    codigo: '86.885',
    departamento: 'Putumayo',
    normalizada: 'villagarzon',
  },
  {
    nombre: 'Villagómez',
    codigo: '25.871',
    departamento: 'Cundinamarca',
    normalizada: 'villagomez',
  },
  {
    nombre: 'Villahermosa',
    codigo: '73.87',
    departamento: 'Tolima',
    normalizada: 'villahermosa',
  },
  {
    nombre: 'Villamaría',
    codigo: '17.873',
    departamento: 'Caldas',
    normalizada: 'villamaria',
  },
  {
    nombre: 'Villanueva',
    codigo: '13.873',
    departamento: 'Bolívar',
    normalizada: 'villanueva',
  },
  {
    nombre: 'Villanueva',
    codigo: '44.874',
    departamento: 'La Guajira',
    normalizada: 'villanueva',
  },
  {
    nombre: 'Villanueva',
    codigo: '68.872',
    departamento: 'Santander',
    normalizada: 'villanueva',
  },
  {
    nombre: 'Villanueva',
    codigo: '85.44',
    departamento: 'Casanare',
    normalizada: 'villanueva',
  },
  {
    nombre: 'Villapinzón',
    codigo: '25.873',
    departamento: 'Cundinamarca',
    normalizada: 'villapinzon',
  },
  {
    nombre: 'Villarrica',
    codigo: '73.873',
    departamento: 'Tolima',
    normalizada: 'villarrica',
  },
  {
    nombre: 'Villavicencio',
    codigo: '50.001',
    departamento: 'Meta',
    normalizada: 'villavicencio',
  },
  {
    nombre: 'Villavieja',
    codigo: '41.872',
    departamento: 'Huila',
    normalizada: 'villavieja',
  },
  {
    nombre: 'Villeta',
    codigo: '25.875',
    departamento: 'Cundinamarca',
    normalizada: 'villeta',
  },
  {
    nombre: 'Viotá',
    codigo: '25.878',
    departamento: 'Cundinamarca',
    normalizada: 'viota',
  },
  {
    nombre: 'Viracachá',
    codigo: '15.879',
    departamento: 'Boyacá',
    normalizada: 'viracacha',
  },
  {
    nombre: 'Vista Hermosa',
    codigo: '50.711',
    departamento: 'Meta',
    normalizada: 'vistahermosa',
  },
  {
    nombre: 'Viterbo',
    codigo: '17.877',
    departamento: 'Caldas',
    normalizada: 'viterbo',
  },
  {
    nombre: 'Yacopí',
    codigo: '25.885',
    departamento: 'Cundinamarca',
    normalizada: 'yacopi',
  },
  {
    nombre: 'Yacuanquer',
    codigo: '52.885',
    departamento: 'Nariño',
    normalizada: 'yacuanquer',
  },
  {
    nombre: 'Yaguará',
    codigo: '41.885',
    departamento: 'Huila',
    normalizada: 'yaguara',
  },
  {
    nombre: 'Yalí',
    codigo: '5.885',
    departamento: 'Antioquia',
    normalizada: 'yali',
  },
  {
    nombre: 'Yarumal',
    codigo: '5.887',
    departamento: 'Antioquia',
    normalizada: 'yarumal',
  },
  {
    nombre: 'Yavaraté',
    codigo: '97.889',
    departamento: 'Vaupés',
    normalizada: 'yavarate',
  },
  {
    nombre: 'Yolombó',
    codigo: '5.89',
    departamento: 'Antioquia',
    normalizada: 'yolombo',
  },
  {
    nombre: 'Yondó',
    codigo: '5.893',
    departamento: 'Antioquia',
    normalizada: 'yondo',
  },
  {
    nombre: 'Yopal',
    codigo: '85.001',
    departamento: 'Casanare',
    normalizada: 'yopal',
  },
  {
    nombre: 'Yotoco',
    codigo: '76.89',
    departamento: 'Valle del Cauca',
    normalizada: 'yotoco',
  },
  {
    nombre: 'Yumbo',
    codigo: '76.892',
    departamento: 'Valle del Cauca',
    normalizada: 'yumbo',
  },
  {
    nombre: 'Zambrano',
    codigo: '13.894',
    departamento: 'Bolívar',
    normalizada: 'zambrano',
  },
  {
    nombre: 'Zapatoca',
    codigo: '68.895',
    departamento: 'Santander',
    normalizada: 'zapatoca',
  },
  {
    nombre: 'Zapayán',
    codigo: '47.96',
    departamento: 'Magdalena',
    normalizada: 'zapayan',
  },
  {
    nombre: 'Zaragoza',
    codigo: '5.895',
    departamento: 'Antioquia',
    normalizada: 'zaragoza',
  },
  {
    nombre: 'Zarzal',
    codigo: '76.895',
    departamento: 'Valle del Cauca',
    normalizada: 'zarzal',
  },
  {
    nombre: 'Zetaquira',
    codigo: '15.897',
    departamento: 'Boyacá',
    normalizada: 'zetaquira',
  },
  {
    nombre: 'Zipacón',
    codigo: '25.898',
    departamento: 'Cundinamarca',
    normalizada: 'zipacon',
  },
  {
    nombre: 'Zipaquirá',
    codigo: '25.899',
    departamento: 'Cundinamarca',
    normalizada: 'zipaquira',
  },
  {
    nombre: 'Zona Bananera',
    codigo: '47.98',
    departamento: 'Magdalena',
    normalizada: 'zonabananera',
  },
];

/* Mapa de ciudades a departamentos */
export const MAPA_CIUDADES_A_DEPARTAMENTOS: Record<string, string[]> = DATOS_CIUDADES.reduce(
  (mapa: Record<string, string[]>, ciudad: Ciudad) => {
    if (!mapa[ciudad.nombre]) mapa[ciudad.nombre] = [];
    mapa[ciudad.nombre].push(ciudad.departamento);
    return mapa;
  },
  {},
);

/**
 * Mapa de ciudades a sus departamentos, como `MAPA_CIUDADES_A_DEPARTAMENTOS`, pero solo
 * con los municipios de una cobertura (la de solicitudes de una organización).
 * @param {{ departamento: string; municipios: string[] }[]} cobertura - Los departamentos
 * con sus municipios.
 * @returns {Record<string, string[]>} - Cada ciudad con los departamentos donde está.
 * @author Juan Corral
 */
export function mapaCiudadesCubiertas(
  cobertura: { departamento: string; municipios: string[] }[],
): Record<string, string[]> {
  const mapa: Record<string, string[]> = {};
  for (const { departamento, municipios } of cobertura) {
    for (const municipio of municipios) (mapa[municipio] ??= []).push(departamento);
  }
  return mapa;
}
